// Português do Brasil: "você", tom próximo e direto.
export default {
  languages: {
    English: 'Inglês',
    Spanish: 'Espanhol',
    Portuguese: 'Português',
    French: 'Francês',
    German: 'Alemão',
    Italian: 'Italiano',
    Arabic: 'Árabe',
    Russian: 'Russo',
    Japanese: 'Japonês',
    Korean: 'Coreano',
    Hindi: 'Hindi',
    Chinese: 'Chinês',
    Bengali: 'Bengali',
    Indonesian: 'Indonésio',
    Turkish: 'Turco',
    Urdu: 'Urdu',
    Tamil: 'Tâmil',
    Persian: 'Persa',
    Romanian: 'Romeno',
    Filipino: 'Filipino',
    Kazakh: 'Cazaque',
  },

  styles: {
    realistic: { label: 'Realista', description: 'Estilo detalhado e fiel à realidade' },
    cinematic: { label: 'Cinematográfico', description: 'Cenas dramáticas, como de filme' },
    '3d-animation': { label: 'Cartoon 3D', description: 'Visual de filme animado em 3D, em imagens' },
    cartoon: { label: 'Desenho animado', description: 'Contornos fortes, cores chapadas e vivas' },
    'comic-book': { label: 'Quadrinhos', description: 'Nanquim e retícula, como uma graphic novel' },
    storybook: { label: 'Livro ilustrado', description: 'Ilustração acolhedora de livro infantil' },
    'anime-realism': { label: 'Anime realista', description: 'Anime cru e realista' },
    anime: { label: 'Anime', description: 'Estilo japonês com olhos expressivos' },
    'dreamy-anime': { label: 'Anime de sonho', description: 'Anime pintado à mão, exuberante e acolhedor' },
    'oil-portrait': { label: 'Retrato a óleo', description: 'Estilo renascentista, texturas ricas' },
    watercolor: { label: 'Aquarela', description: 'Cores pastel, textura de pintura' },
    'ink-sketch': { label: 'Esboço a nanquim', description: 'Tinta preta, hachuras' },
    'pop-art': { label: 'Pop art', description: 'Alto contraste, cores vibrantes' },
    collage: { label: 'Colagem', description: 'Composição artesanal em camadas' },
    'paper-cutout': { label: 'Recorte de papel', description: 'Camadas de papel, formas simples' },
    'ukiyo-e': { label: 'Ukiyo-e', description: 'Xilogravura japonesa' },
    kawaii: { label: 'Kawaii', description: 'Fofo, em tons pastel' },
    claymation: { label: 'Massinha', description: 'Bonecos de massinha em stop motion' },
    'pixel-art': { label: 'Pixel art', description: 'Pixels de videogame retrô de 16 bits' },
    'low-poly': { label: 'Low poly', description: '3D facetado, visual de jogo indie' },
    'fantasy-epic': { label: 'Fantasia épica', description: 'Magia, castelos, alta fantasia' },
    cyberpunk: { label: 'Cyberpunk', description: 'Luzes neon, cidade futurista' },
    'vintage-retro': { label: 'Vintage retrô', description: 'Inspirado nos anos 70, 80 e 90, tons quentes' },
    'noir-film': { label: 'Filme noir', description: 'Preto e branco, iluminação dramática' },
    spooky: { label: 'Terror', description: 'Sombrio e perturbador, sombras intensas' },
  },

  // A narrator's voice: a man's or a woman's (i18n/narration.js VOICE_GENDERS)
  voiceGender: {
    man: 'Homem',
    woman: 'Mulher',
  },
  voices: {
    alloy: 'Neutra e equilibrada, clara e versátil',
    ash: 'Suave e natural, com tom acolhedor',
    ballad: 'Delicada, expressiva e melódica',
    coral: 'Calorosa e amigável, tom médio',
    echo: 'Clara e ressonante, um pouco formal',
    fable: 'Expressiva, ótima para contar histórias',
    nova: 'Enérgica, jovem e vibrante',
    onyx: 'Grave, firme e com autoridade',
    sage: 'Calma, reflexiva e sábia',
    shimmer: 'Leve, alegre e animada',
    verse: 'Articulada, de narrador profissional',
    puck: 'Animado e brincalhão, ótimo para curiosidades',
    kore: 'Firme e confiante, feita para explicar',
    fenrir: 'Empolgado e rápido, para esportes e hype',
    aoede: 'Leve e descontraída, para lifestyle e viagens',
    enceladus: 'Grave e sussurrada, para terror e mistério',
    algenib: 'Rouca e dramática, como trailer de filme',
    despina: 'Suave e elegante, para luxo e marcas',
    achernar: 'Suave e tranquila, para calma e histórias de dormir',
    zephyr: 'Animada e alegre, para crianças e tutoriais',
    sadaltager: 'Experiente, como um apresentador de documentário',
    zubenelgenubi: 'Casual e tranquilo, como conversar com um amigo',
    pulcherrima: 'Ousada e direta, para motivação',
  },

  sidebar: {
    label: 'Aplicativo',
    home: 'Início',
    create: 'Criar',
    fromVideo: 'A partir de um vídeo',
    collapse: 'Recolher a barra lateral',
    expand: 'Abrir a barra lateral',
    managePlan: 'Gerenciar o plano',
  },
  dashboard: {
    seoTitle: 'Início',
    kicker: 'Início',
    title: 'O que vamos fazer hoje?',
    titleNamed: 'O que vamos fazer hoje, {name}?',
    subtitle: 'Escreva uma ideia e o Agente de IA faz o vídeo. Ou comece de um vídeo que você já tem.',
    placeholder: 'Descreva seu vídeo em uma frase…',
    make: 'Criar',
    recent: 'Recentes',
    seeAll: 'Ver tudo',
    empty: 'Nada ainda. Seu primeiro vídeo começa com uma frase, acima.',
    ready: 'Pronto',
    making: 'Em andamento',
    failed: 'Falhou',
    untitled: 'Sem título',
  },
  nav: {
    features: 'Recursos',
    pricing: 'Preços',
    login: 'Entrar',
    getStarted: 'Começar',
    getStartedFree: 'Comece grátis',
    create: 'Criar',
    menu: 'Menu',
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    themeSystem: 'Como o aparelho',
    usage: 'Uso',
    videoMinutes: 'Minutos de vídeo',
    aiAgentVideos: 'Vídeos do Agente de IA',
    upgrade: 'Fazer upgrade para Pro',
    myAccount: 'Minha conta',
    admin: 'Painel de administração',
    logout: 'Sair',
    user: 'Usuário',
    tools: 'Ferramentas',
    minutesLeft: 'Você ainda tem {n} minutos de processamento de vídeo.',
    minutesUnlimited: 'Você tem minutos de processamento ilimitados.',
    agentLeft: 'Você ainda tem {n} vídeos do Agente de IA.',
    trialShort: 'Teste: {n} d',
    trialEnds: 'O teste termina em {date}',
    trialLeftOne: 'Falta {n} dia de teste',
    trialLeftMany: 'Faltam {n} dias de teste',
    badgeNew: 'Novo',
    badgeBeta: 'Beta',
  },
  tools: {
    aiClipping: 'Cortes com IA',
    captions: 'Legendas',
    reframe: 'Reenquadrar',
    editor: 'Editor',
    aiAgent: 'Agente de IA',
  },
  featureLinks: {
    aiClipping: { label: 'Cortes com IA', description: 'Transforme vídeos longos em shorts virais' },
    autoCaption: { label: 'Legendas automáticas', description: 'Legendas com estilo para qualquer vídeo' },
    reframe: { label: 'Reenquadramento com IA', description: 'Adapte vídeos inteiros com corte inteligente' },
    aiAgent: { label: 'Agente de IA', description: 'Crie vídeos a partir de uma ideia com IA' },
    editor: { label: 'Editor de vídeo online', description: 'Edição profissional no navegador' },
  },
  createActions: {
    aiClipping: { label: 'Cortes com IA', description: 'Extraia os melhores momentos dos seus vídeos' },
    autoCaption: { label: 'Legendas automáticas', description: 'Adicione legendas com estilo aos vídeos' },
    reframe: { label: 'Reenquadrar vídeo', description: 'Corte e ajuste o formato com IA' },
    aiAgent: { label: 'Agente de IA', description: 'Crie vídeos a partir de uma ideia' },
    scenes: { label: 'Cenas', description: 'Uma tomada animada com som e vozes' },
    editor: { label: 'Editor de vídeo', description: 'Edite vídeos no navegador' },
    series: {
      label: 'Séries',
      description: 'Vídeos novos em um horário ou quando quiser',
    },
    characters: { label: 'Personagens', description: 'Um elenco igual em todos os vídeos' },
  },

  footer: {
    monetizeGuide: 'Monetizar vídeos com IA',
    clipYtShorts: 'Do YouTube para Shorts',
    clipPodcasts: 'Clipes de podcast',
    clipStreams: 'Clipes de lives',
    clipClippers: 'Para clippers',
    canalDarkGuide: 'Como fazer um canal dark',
    company: 'Empresa',
    about: 'Sobre o Clip-Short',
    videoReframe: 'Reenquadrar vídeo',
    videoEditor: 'Editor de vídeo',
    faq: 'Perguntas frequentes',
    affiliates: 'Programa de afiliados',
    privacy: 'Política de privacidade (em inglês)',
    cookies: 'Preferências de cookies',
    signUp: 'Cadastre-se grátis',
    language: 'Idioma',
    copyright: '© {year} Clip-Short.com - Plataforma de vídeo com IA',
    tools: 'Ferramentas',
    freeTools: 'Ferramentas grátis',
    guides: 'Guias',
    compareUseCases: 'Comparações e casos de uso',
    characters: 'Personagens',
    remix: 'Remix',
    scenes: 'Cenas',
    yourProjects: 'Seus projetos',
    account: 'Conta',
  },

  consent: {
    title: 'Usamos cookies de análise e para medir nossos anúncios',
    allow: 'Aceitar cookies',
    decline: 'Recusar',
    manage: 'Configurar',
    learnMore: 'Saiba mais na nossa',
    policy: 'Política de privacidade e cookies',
    dialogTitle: 'Preferências de privacidade',
    dialogBody: 'Escolha quais cookies e armazenamento opcionais usamos. Os dados essenciais (para login e para lembrar suas preferências) ficam sempre ativos.',
    dialogBodyShort: 'Escolha os cookies opcionais. Os dados essenciais ficam sempre ativos.',
    analytics: 'Análise',
    analyticsBody: 'Permita que o PostHog e o Vercel Speed Insights registrem tendências de uso do produto, e que o Google Ads nos diga se um anúncio nosso trouxe você até aqui. Isso nos ajuda a melhorar recursos e desempenho sem identificar você diretamente.',
    analyticsBodyShort: 'Nos ajuda a melhorar recursos e desempenho, e a medir nossos anúncios.',
    toggle: 'Ativar ou desativar cookies de análise',
    readMore: 'Veja como usamos cookies e dados na nossa',
    revisit: 'Você pode mudar essas configurações quando quiser pelo menu ou pelo aviso de cookies.',
    revisitShort: 'Mude quando quiser pelo menu.',
    reset: 'Redefinir decisão',
    close: 'Fechar',
  },

  agentFormats: {
    label: 'Formato',
    story: 'História',
    countdown: 'Top 5',
    quiz: 'Quiz / o que você prefere?',
    chat: 'História em chat',
    pov: 'POV: você está lá',
  },
  publish: {
    posted: {
      title: 'Já postou?',
      hint: 'Marque onde você postou, para não perder a conta.',
      seriesHint: 'Marque onde você postou. A série puxa as próximas ideias para os episódios que você posta.',
      since: 'Marcado como postado em {day}',
      failed: 'Não deu para salvar. Tente de novo.',
    },
    button: 'Postar',
    title: 'Poste este vídeo',
    subtitle: 'Textos escritos para cada rede no idioma do seu vídeo. Edite, copie e poste.',
    platforms: 'Redes',
    writing: 'Escrevendo o post…',
    writeFailed: 'Não foi possível escrever. Tente de novo.',
    copy: 'Copiar texto',
    copied: 'Copiado',
    copyOne: 'Copiar',
    copyAll: 'Copiar tudo',
    rewrite: 'Escrever de novo',
    write: 'Escrever o texto do post',
    aiLabel: 'No YouTube, ative "Conteúdo alterado ou sintético" se o vídeo mostrar pessoas ou fatos realistas feitos com IA.',
    shareToApp: 'Enviar para o app',
    shareGettingReady: 'Preparando o vídeo…',
    shareFailed: 'O seu celular não aceitou o vídeo. Salve no aparelho e envie pelo app.',
    openPlatform: 'Abrir {platform}',
    scheduleTitle: 'Postar depois',
    scheduleHint: 'Vamos te mandar por e-mail o vídeo e estes textos nessa hora.',
    schedule: 'Me lembre',
    scheduleFailed: 'Não foi possível agendar. Escolha um horário nos próximos 60 dias.',
    cancel: 'Cancelar',
    platform: {
      tiktok: 'TikTok',
      youtube: 'YouTube Shorts',
      instagram: 'Instagram Reels',
      facebook: 'Facebook Reels',
    },
    fields: {
      title: 'Título',
      description: 'Descrição',
      caption: 'Legenda',
      tags: 'Tags',
    },
    shareSubtitle: 'Textos para cada plataforma, um lembrete para depois e um link que qualquer pessoa pode abrir.',
  },
  usageLimit: {
    title: "Você chegou ao limite deste mês",
    minutes: "Você usou os minutos de vídeo deste período.",
    aiVideos: "Você usou os vídeos com IA deste período.",
    upgrade: "Um plano maior dá mais a cada mês.",
    close: "Fechar",
    pricing: "Ver planos",
  },
  translateVideo: {
    versions: "Em outros idiomas:",
    original: "Ver o original",
    translating: "Traduzindo…",
    button: 'Traduzir',
    title: 'Faça em outro idioma',
    subtitle: 'As mesmas imagens, com a narração e os textos traduzidos e narrados de novo com a mesma voz.',
    costsOne: 'É um vídeo novo, então usa um dos vídeos de IA do seu plano.',
    make: 'Fazer o vídeo',
    failed: 'Não foi possível começar a tradução. Tente de novo.',
    outOfVideos: "Você não tem mais vídeos de IA. Faça upgrade para fazer mais.",
  },
  // Your own voice (components/voices, api/services/voices.py)
  ownVoice: {
    group: 'Suas vozes',
    record: 'Grave sua voz',
    recordHint: 'Narre seus vídeos com a sua própria voz',
    paidOnly: 'Sua própria voz está nos planos pagos',
    upgrade: 'Ver planos',
    slow: 'Sua própria voz demora mais: cerca de 5 minutos por minuto de narração, em vídeos de até {minutes} minutos.',
    tooLong: 'Sua própria voz narra vídeos de até {minutes} minutos. Escolha uma duração menor ou outra voz.',
    play: 'Ouvir {name}',
    sampleMaking: 'Preparando uma amostra com esta voz…',
    dialog: {
      title: 'Grave sua voz',
      subtitle: 'Leia uma frase em voz alta e fazemos a sua voz com ela. Ela pode narrar seus vídeos em português, inglês, espanhol, árabe e mais.',
      ownOnly: 'Grave só a sua própria voz. A frase que você lê é a sua autorização e traz palavras novas a cada vez, então a gravação de outra pessoa não serve.',
      language: 'O idioma em que você vai ler',
      name: 'Nome (opcional)',
      namePlaceholder: 'Minha voz',
      getSentence: 'Mostrar a frase',
      readThis: 'Leia isto em voz alta, com a sua voz de sempre:',
      start: 'Começar a gravar',
      stop: 'Parar',
      recording: 'Gravando… {seconds} s',
      again: 'Gravar de novo',
      save: 'Salvar minha voz',
      saving: 'Conferindo sua gravação…',
      saved: 'Sua voz está pronta. Escolha-a como narrador.',
      tips: 'Um lugar silencioso, o celular ou microfone a um palmo, de 10 a 20 segundos.',
    },
    errors: {
      microphone: 'Não conseguimos usar seu microfone. Permita no navegador e tente de novo.',
      micBlocked: 'Seu navegador bloqueou o microfone. Permita para clip-short.com (o ícone no início da barra de endereço) e tente de novo.',
      micBlockedIos: 'Seu iPhone bloqueou o microfone. No Safari: toque no menu da página na barra de endereço, depois em Ajustes do Site e Microfone: Permitir. No Chrome: abra o app Ajustes, depois Chrome, e ative Microfone. Depois tente de novo.',
      micMissing: 'Não encontramos nenhum microfone. Conecte um e tente de novo.',
      micBusy: 'Outro app está usando o microfone (uma ligação ou um gravador). Feche-o e tente de novo.',
      sentence_not_heard: 'Não ouvimos a frase inteira, com as três palavras do final. Leia de novo, um pouco mais perto do microfone.',
      too_short: 'Ficou curto demais. Leia a frase inteira; leva uns 10 segundos.',
      consent_expired: 'Essa frase expirou. Aqui está uma nova.',
      unreadable_recording: 'Não conseguimos ler essa gravação. Tente de novo.',
      too_many_voices: 'Você já tem 3 vozes. Apague uma em Conta, Vozes, para fazer outra.',
      paid_plan_required: 'Sua própria voz está nos planos pagos.',
      voice_unavailable: 'Gravar vozes não está disponível agora. Tente mais tarde.',
      voice_not_found: 'Essa voz foi apagada. Escolha outra.',
      own_voice_too_long: 'Sua própria voz narra vídeos de até 3 minutos. Escolha uma duração menor ou outra voz.',
      generic: 'Algo deu errado. Tente de novo.',
    },
    account: {
      nav: 'Vozes',
      title: 'Suas vozes',
      subtitle: 'Vozes feitas com a sua própria gravação. Só você pode usá-las.',
      empty: 'Nenhuma voz ainda.',
      delete: 'Apagar',
      deleteQuestion: 'Apagar esta voz? Os vídeos que você já fez mantêm o som.',
      deleteConfirm: 'Apagar',
      keep: 'Manter',
      recorded: 'Gravada em {language}',
    },
  },
  clipsCard: {
    title: 'Tem um vídeo longo?',
    text: 'O AI Clipping corta em clipes curtos com legendas.',
    button: 'Gerar cortes',
    close: 'Fechar',
  },
  aiAgentTabs: {
    video: 'Vídeo',
    scenes: 'Cenas',
    label: 'Agente de IA',
    create: 'Criar um vídeo',
    series: 'Séries',
    characters: 'Personagens',
  },
  characters: {
    title: 'Personagens',
    subtitle: 'Seu elenco fixo. Descreva um personagem uma vez e ele fica igual em cada cena, cada vídeo e cada episódio.',
    new: 'Novo personagem',
    yours: 'Seu elenco ({n} de {max})',
    yoursUncapped: 'Seu elenco ({n})',
    loadError: 'Não conseguimos carregar seus personagens. Atualize a página para tentar de novo.',
    emptyTitle: 'Crie seu primeiro personagem',
    emptyText: 'Um herói para suas histórias, um apresentador para seu canal, um mascote para sua marca.',
    deleteTitle: 'Apagar {name}?',
    deleteText: 'Os vídeos que você já fez mantêm as imagens. As séries com este personagem continuam sem ele.',
    keep: 'Manter',
    delete: 'Apagar',
    demo: {
      kicker: 'Personagens consistentes',
      title: 'O mesmo personagem em cada cena',
      text: 'Imagens de IA costumam mudar o rosto de uma cena para outra. Um personagem é desenhado uma vez como referência, e cada imagem em que ele aparece é desenhada a partir dela.',
      steps: {
        describe: 'Descreva como ele é: idade, rosto, cabelo, roupa, cores.',
        draw: 'Desenhamos o retrato de referência. Desenhe de novo até ficar certo.',
        use: 'Escolha-o para um vídeo ou para uma série inteira.',
      },
      frames: {
        portrait: 'A referência',
        scene1: 'Cena 1',
        scene2: 'Cena 4',
      },
    },
    card: {
      edit: 'Editar {name}',
      delete: 'Apagar {name}',
      video: 'Usar em um vídeo',
      series: 'Começar uma série',
    },
    dialog: {
      newTitle: 'Novo personagem',
      editTitle: 'Editar {name}',
      subtitle: 'Descreva o que nunca muda nele. O retrato vira a referência de cada imagem em que ele aparece.',
      name: 'Nome',
      namePlaceholder: 'Nour',
      look: 'Como ele é',
      lookPlaceholder: 'Uma menina de 10 anos com cabelo preto cacheado preso, um lenço verde, uma camiseta amarela e um macacão jeans, olhos castanhos corajosos',
      lookHint: 'Idade, rosto, cabelo, porte, roupa e cores. Quanto mais específico, mais ele continua igual.',
      style: 'Desenhado em',
      preview: 'O retrato aparece aqui.',
      drawing: 'Desenhando {name}… cerca de 15 segundos',
      drawingShort: 'Desenhando…',
      portraits: 'Todos os desenhos até agora. Toque em um para usar.',
      portraitInUse: 'Em uso',
      portraitPick: 'Usar o desenho {n}',
      consistent: 'Este retrato é o que mantém o personagem igual em cada imagem. Desenhe de novo até ficar certo.',
      draw: 'Desenhar personagem',
      redraw: 'Desenhar de novo',
      redrawChanged: 'Desenhar com as mudanças',
      done: 'Pronto',
      picture: 'Comece de uma imagem (opcional)',
      pictureHint: 'Envie um desenho, seu pet, um mascote ou uma foto sua',
      pictureLooking: 'Olhando sua imagem…',
      pictureOther: 'Escrevemos como ele é a partir da sua imagem. Mude o que quiser abaixo.',
      picturePerson: 'A foto de uma pessoa é sempre desenhada como ilustração, em um dos estilos desenhados.',
      pictureConsent: 'Sou eu, ou tenho a permissão da pessoa para usar a foto dela.',
      pictureRemove: 'Remover a imagem',
      styleIllustratedOnly: 'Desenhado a partir da foto de uma pessoa, então os estilos fotográficos ficam desligados.',
    },
    ideas: {
      girl: { label: 'Uma jovem exploradora', name: 'Nour', look: 'Uma menina de 10 anos com cabelo preto cacheado preso, um lenço verde, uma camiseta amarela e um macacão jeans, olhos castanhos corajosos' },
      grandfather: { label: 'Um contador de histórias', name: 'Vovô Samuel', look: 'Um senhor gentil de barba branca curta, óculos redondos, um cardigã de tricô marrom sobre uma camisa branca, sorriso caloroso' },
      detective: { label: 'Uma detetive', name: 'Detetive Vale', look: 'Uma mulher de uns 40 anos de cabelo prateado curto, um casaco longo cinza-escuro, um cachecol vermelho, olhos cinzentos atentos' },
      robot: { label: 'Um robô parceiro', name: 'Bolt', look: 'Um pequeno robô redondo de carcaça branca, um grande olho azul brilhante, antenas laranja curtas e rodinhas' },
    },
    picker: {
      label: 'Personagens',
      optional: '(opcional)',
      manage: 'Gerenciar',
      remove: 'Tirar {name}',
      add: 'Adicionar um personagem',
      create: 'Criar um personagem',
      hint: 'Adicione um personagem fixo e ele fica igual em cada imagem.',
      chosenHint: 'Eles ficam iguais em cada imagem. Cite-os na sua ideia para dar um papel a eles.',
      seriesHint: 'Cada episódio acompanha um deles, em revezamento: até {max} numa série. Toque num nome para mudá-lo.',
      title: 'Escolha personagens',
      subtitle: 'Até {max}. Cada um mantém o mesmo rosto em cada imagem.',
      seriesHintAny: 'Cada episódio acompanha os que a ideia dele cita, em revezamento. Toque num nome para mudá-lo.',
      subtitleAny: 'Cada um mantém o mesmo rosto em cada imagem.',
      new: 'Novo personagem',
      done: 'Pronto',
    },
    errors: {
      character_incomplete: 'Dê um nome e descreva como ele é em uma ou duas frases.',
      too_many_characters: 'Você tem 12 personagens. Apague um para criar outro.',
      name_taken: 'Você já tem um personagem com esse nome.',
      too_many_portraits: 'Esses foram os retratos de hoje. Tente amanhã.',
      portrait_failed: 'Não conseguimos desenhar esse retrato. Tente de novo ou mude a descrição.',
      character_not_found: 'Um dos personagens foi apagado. Escolha outro.',
      photo_of_a_child: 'Não criamos personagens a partir de fotos de crianças. Descreva a criança, ou envie um desenho.',
      photo_consent_needed: 'Marque a caixa para confirmar que a foto é sua, ou que você tem a permissão da pessoa.',
      photo_needs_illustrated_style: 'A foto de uma pessoa só é desenhada em um estilo ilustrado. Escolha outro estilo.',
      picture_unreadable: 'Não conseguimos ler essa imagem. Tente um JPG ou PNG.',
      picture_too_large: 'Essa imagem é grande demais. Tente uma com menos de 8 MB.',
      too_many_looks: 'Essas foram as imagens de hoje. Tente de novo amanhã.',
      look_failed: 'Não conseguimos olhar essa imagem. Tente de novo.',
      generic: 'Algo deu errado. Tente de novo.',
    },
  },
  // Séries do Agente de IA (pages/SeriesPage.jsx): cada episódio espera pelo dono, e a
  // originalidade é uma estimativa, nunca a decisão do YouTube
  series: {
    title: 'Séries',
    subtitle: "Os próximos vídeos do seu canal: um episódio novo sobre o seu tema, no horário que você escolher, cada um com um ângulo novo.",
    promise: 'Cada episódio espera por você. Nada é postado até você revisar e postar.',
    back: 'Agente de IA',
    link: 'Transforme em série',
    linkHint: 'Um episódio novo no seu horário, esperando sua revisão',
    how: {
      review: { title: 'Quem posta é você', text: 'Cada episódio é preparado e chega no seu e-mail. Assista, mude e poste quando quiser.' },
      angles: { title: 'Um ângulo novo a cada vez', text: 'Cada episódio traz outra história, fato ou ângulo do seu tema, nunca um repetido.' },
      check: { title: 'Uma checagem de originalidade', text: 'Cada episódio é comparado com os anteriores, e avisamos antes de a série ficar repetitiva.' },
    },
    form: {
      title: 'Começar uma série',
      topic: 'Sobre o que é o canal?',
      topicPlaceholder: 'Lendas e mitos do antigo Egito, contados para adultos. Uma lenda por vídeo, fiel a como é contada de verdade.',
      topicHint: 'Cada episódio traz uma história, um fato ou um ângulo diferente sobre isso.',
      topicTooShort: 'Descreva o canal em uma ou duas frases.',
      name: 'Nome da série (opcional)',
      namePlaceholder: 'Lendas do Egito',
      format: 'Formato',
      style: 'Estilo visual',
      language: 'Idioma da narração',
      voice: 'Narrador',
      duration: 'Duração',
      aspect: 'Formato de tela',
      cadence: 'Com que frequência',
      start: 'Primeiro episódio',
      startNow: 'Agora',
      startLater: 'Num horário que eu escolher',
      cost: 'Cada episódio usa um dos vídeos com IA do seu plano. Se acabarem, a série pausa e avisamos por e-mail.',
      submit: 'Começar a série',
      creating: 'Começando…',
      freeLength: 'As séries são um recurso Pro: faça upgrade para fazer esta série.',
      tooMany: 'Você já tem 10 séries. Pare uma para começar outra.',
      error: 'Não conseguimos começar a série. Confira os campos e tente de novo.',
    },
    cadence: {
      24: 'Todo dia',
      48: 'Dia sim, dia não',
      56: '3 vezes por semana',
      168: 'Toda semana',
    },
    status: {
      active: 'Ativa',
      paused: 'Pausada',
    },
    paused: {
      unreviewed: "Pausada: 5 episódios prontos esperam por você. Assista a um e a série continua.",
      voice: 'Pausada: a voz do narrador foi apagada. Escolha outra e retome.',
      user: 'Pausada por você.',
      out_of_videos: 'Pausada: seu plano não tem mais vídeos com IA neste período. Retome quando renovarem, ou faça upgrade.',
      pro: "Pausada: séries são um recurso do Pro. Seus episódios continuam aqui; assine o Pro para continuar.",
      goPro: "Assinar o Pro",
      out_of_minutes: 'Pausada: seu plano não tem mais minutos. Retome quando renovarem, ou faça upgrade.',
      longer_than_plan: 'Pausada: seu plano faz vídeos de 30 segundos. Deixe os episódios mais curtos, ou faça upgrade.',
      videosBack: 'Seus vídeos com IA voltaram: restam {n}. Retome a série para continuar.',
      account: 'Pausada.',
    },
    settings: {
      cast: 'Personagens',
      noCast: 'Sem personagem fixo',
      changeCast: 'Mudar os personagens',
      castTitle: 'Os personagens da série',
      castHint: 'Cada imagem que os cita os desenha igual. Os próximos episódios seguem; os já feitos ficam como estão.',
      look: 'Visual',
      changeLook: 'Mudar o visual',
      lookTitle: 'O visual da série',
      lookHint: 'Os próximos episódios começam com isto. Os já feitos ficam como estão.',
      noTitleCard: 'Sem cartelas',
      schedule: 'Agenda',
      changeSchedule: 'Mudar a agenda',
      failed: 'Não deu para salvar. Tente de novo.',
    },
    page: {
      numbers: {
        made: 'Episódios feitos',
        waiting: 'Esperando você',
        posted: 'Postados',
        liked: 'Curtidos',
      },
    },
    ready: {
      title: 'O episódio {n} está pronto',
      watch: 'Assistir',
      dismiss: 'Fechar',
    },
    list: {
      steps: {
        script: 'Escrevendo o roteiro',
        pictures: 'Desenhando as imagens e gravando a voz',
        together: 'Juntando tudo',
        finishing: 'Finalizando',
      },
      title: 'Suas séries',
      empty: 'Nenhuma série ainda. Comece uma acima: o primeiro episódio é preparado em um minuto, ou no horário que você escolher.',
      loadError: 'Não conseguimos carregar suas séries. Recarregue a página para tentar de novo.',
      noEpisodes: 'O primeiro episódio será preparado no horário que você escolheu.',
      next: 'Próximo episódio: {when}',
      nextSoon: 'O próximo episódio está sendo preparado agora.',
      episode: 'Ep. {n}',
      pause: 'Pausar',
      resume: 'Retomar',
      delete: "Excluir a série",
      deleteConfirm: 'Nenhum episódio novo será preparado. Os que já foram feitos continuam nos seus projetos.',
      keep: 'Manter',
    },
    episodeState: {
      posted: 'Postado',
      reviewed: 'Revisado',
      drafting: 'Preparando…',
      ready: 'Pronto para revisar',
      failed: 'Falhou',
    },
    check: {
      okBadge: 'Parece original',
      warnBadge: "Parecido demais",
      ok: 'Está diferente dos seus últimos {n} episódios: no título, na ideia e nas primeiras palavras.',
      first: 'O primeiro episódio: ainda não há com o que comparar.',
      advice: 'Reescreva as primeiras frases ou dê outro ângulo antes de postar: aberturas repetidas e modelos são o que o YouTube chama de conteúdo não autêntico.',
      disclaimer: 'Uma estimativa feita com as palavras dos seus episódios, não a decisão do YouTube.',
      reasons: {
        same_title: 'O título é quase igual ao do episódio {episode}.',
        same_idea: 'A ideia é parecida com a do episódio {episode}.',
        opening: 'Começa quase palavra por palavra como o episódio {episode}.',
        openings: '{similar} dos seus últimos {n} episódios começam quase do mesmo jeito.',
        titles: '{similar} dos seus últimos {n} títulos seguem o mesmo padrão.',
      },
    },
    look: {
      titleCard: 'Cartelas',
      title: 'O visual da série: os novos episódios começam com estas legendas e esta música. Mude em qualquer episódio.',
      captions: 'Legendas: {name}',
      customCaptions: 'personalizadas',
      noCaptions: 'Sem legendas',
      music: 'Música: {name}',
      noMusic: 'Sem música',
    },
    alsoIn: {
      label: 'Faça também cada episódio em',
      hint: 'Até {max} idiomas a mais: as mesmas imagens, narradas de novo. Cada um usa mais um vídeo com IA do seu plano.',
      summary: 'Também em {languages}, mais um vídeo com IA cada',
      chip: 'Também em {languages}',
      versions: "Outros idiomas",
      failed: "Não deu para fazer",
      translating: 'Traduzindo…',
      skipped: 'Não foi feito: acabaram os vídeos com IA',
      skippedOther: 'Não deu para fazer',
    },
    inspiration: {
      open: 'Comece de um canal que você curte',
      openHint: 'o nicho dele, o seu ângulo',
      label: 'Um canal do YouTube que você curte',
      placeholder: 'youtube.com/@canal ou @canal',
      suggest: 'Sugerir',
      reading: 'Lendo o canal…',
      close: 'Fechar',
      filled: 'Preenchido a partir de {channel}: o nicho dele, o seu ângulo. Mude o que quiser.',
      whatWorks: 'O que funciona lá:',
      different: 'O seu é diferente:',
      firstIdeas: 'Os primeiros episódios podem ser:',
      errors: {
        bad_link: 'Isso não é um link de canal ou vídeo do YouTube.',
        not_found: 'O YouTube não tem nenhum canal nesse link.',
        no_videos: 'Esse canal não tem vídeos públicos para ler.',
        unavailable: 'Isso não está disponível agora.',
        too_many: 'Já foram canais suficientes hoje. Tente de novo amanhã.',
        other: 'Não deu para ler esse canal. Tente de novo.',
      },
    },
    calendar: {
      title: 'O que vem por aí',
      hint: "Os próximos 7 dias das suas séries e seus lembretes para postar.",
      today: 'Hoje',
      tomorrow: 'Amanhã',
      newIdea: 'Uma ideia nova',
      post: 'Postar: {title}',
      yourVideo: 'seu vídeo',
      dragHint: "Arraste um episódio para outro dia para mudar quando ele é feito, ou use o botão Mover. Os episódios seguintes dessa série se movem junto.",
      touchHint: "Toque em Mover em um episódio para mudar o dia em que ele é feito. Os episódios seguintes dessa série se movem junto.",
      move: "Mover",
      moveTo: "Mover para",
      moved: "Movido para {day} ({time}). Os episódios seguintes dessa série se movem junto.",
      moveFailed: "Não foi possível mover. Tente de novo.",
      grip: "Arraste para outro dia",
    },
    autoExport: {
      label: 'Exporte cada episódio para mim',
      hint: 'Cada episódio chega como um vídeo pronto no visual da série, para baixar e postar. Você ainda pode mudar e exportar de novo.',
      chip: 'Exportado para você',
      exporting: 'Exportando…',
      download: 'Baixar',
    },
    create: {
      title: 'Comece uma série',
      editTitle: 'Editar {name}',
      editSubtitle: "As mudanças valem para os próximos episódios. Os que já foram feitos ficam como estão.",
      subtitle: "Um vídeo novo sobre o seu tema, no horário que você escolher.",
      back: 'Suas séries',
      notFound: 'Esta série não é sua ou não existe mais.',
      cancel: 'Cancelar',
      previous: 'Voltar',
      next: 'Próximo: {step}',
      start: 'Começar a série',
      starting: 'Começando…',
      save: 'Salvar mudanças',
      saving: 'Salvando…',
      savedNote: 'Salvo. Os próximos episódios seguem os novos ajustes.',
      startedOne: "Sua série está pronta. O episódio 1 está sendo feito e fica pronto para assistir em alguns minutos.",
      startedMany: "Sua série está pronta. Os primeiros {n} episódios estão sendo feitos e ficam prontos para assistir em alguns minutos.",
      startedAt: "Sua série está pronta. O primeiro episódio é feito {when}.",
      startedLater: "Sua série está pronta.",
      steps: {
        idea: 'Ideia',
        look: 'Visual e som',
        when: 'Quando',
      },
      topic: 'Sobre o que é a sua série?',
      topicPlaceholder: 'ex. Lendas do folclore brasileiro contadas para adultos, uma por episódio',
      starterReplaced: 'Sua própria ideia foi substituída.',
      starterUndo: 'Voltar à minha ideia',
      topicHint: 'Uma ou duas frases bastam. Cada episódio traz uma história, um fato ou um ângulo novo.',
      niches: {
        title: 'Ou comece por um nicho que funciona',
        hint: 'Um toque escolhe o tema, o formato, o visual, a música e a voz, e escreve os primeiros episódios. Depois mude o que quiser.',
      },
      captions: {
        title: 'Legendas',
        hint: 'Como a narração aparece na tela, igual em todos os episódios.',
        off: 'Sem legendas',
        more: "Mais {n} estilos",
        custom: 'Seu próprio estilo',
        customHint: 'O estilo que você fez num episódio. Escolha outro para trocar.',
      },
      music: {
        title: 'Música',
        hint: 'Por baixo da narração, da nossa própria biblioteca, sem problema para postar em qualquer lugar.',
        auto: 'Combinando com cada episódio',
        off: 'Sem música',
        listen: 'Ouvir',
        stop: 'Parar',
      },
      hear: {
        play: 'Ouça um episódio',
        stop: 'Parar',
        what: '{voice} · {music}',
        matched: 'música combinando com cada episódio',
        noMusic: 'sem música',
      },
      mock: {
        caption: 'Ninguém sabia por quê',
        countdown: 'Os animais mais rápidos',
        quiz: 'Qual é o planeta mais quente?',
        quizA: 'Vênus',
        quizB: 'Mercúrio',
        pov: 'Você acorda em Roma, ano 79',
        chat1: 'você ouviu isso?',
        chat2: 'ouvi o quê?',
        chat3: 'tem alguém na casa',
      },
      quickStart: {
        button: "Começar assim",
        hint: "O primeiro episódio é feito no horário dele. Mude o que quiser depois.",
        hintNow: "O episódio 1 é feito agora e o resto no horário. Mude o que quiser depois.",
        hintNowMany: "Os primeiros {n} episódios são feitos agora e o resto no horário. Mude o que quiser depois.",
      },
      titleCard: {
        title: 'Abrir cada episódio com o título',
        hint: '"{kicker}" sobre o título do episódio nos primeiros segundos, para todos parecerem o mesmo programa. Mude ou tire em qualquer episódio.',
        episode: 'Ep. {n}',
      },
      seePreview: 'Ver sua série',
      format: 'Como é um episódio',
      formatHints: {
        story: 'Uma história narrada sobre imagens',
        countdown: 'Cinco coisas, até chegar ao #1',
        quiz: 'Perguntas para jogar enquanto assiste',
        chat: 'Uma história contada como chat',
        pov: 'Você está lá, enquanto acontece',
      },
      moreOptions: 'Nome e notas',
      fewerOptions: 'Esconder nome e notas',
      name: 'Nome da série',
      namePlaceholder: 'Vamos dar um nome a partir do seu tema',
      notes: 'Notas que cada episódio segue',
      notesPlaceholder: 'Tom, público, o que fazer sempre e o que nunca',
      noteIdeas: {
        kids: 'Para crianças de 6 a 9 anos',
        gentle: 'Nunca violento nem assustador',
        funny: 'Leve e divertido',
        facts: 'Só fatos reais e checáveis',
      },
      narratorHint: 'Toque no play para ouvir cada uma no idioma da sua série.',
      listen: 'Ouvir {name}',
      stop: 'Parar',
      ownVoiceLine: 'Sua própria voz, até {minutes} min por episódio',
      shapes: {
        '9x16': 'Vertical',
        '16x9': 'Horizontal',
        '1x1': 'Quadrado',
        '4x5': 'Retrato',
      },
      perMonth: 'cerca de {n} vídeos por mês',
      time: 'Em que horário',
      timeHint: 'Cada episódio é preparado nesse horário, no seu relógio, e espera por você.',
      times: {
        morning: 'Manhã',
        afternoon: 'Tarde',
        evening: 'Começo da noite',
        night: 'Noite',
      },
      nowTitle: "Episódios para fazer já",
      nowHint: "Prontos para assistir em alguns minutos, um vídeo com IA cada. O resto segue o horário.",
      nowNone: "Nenhum",
      nowCount: "{n}",
      lengthLocked: 'Episódios mais longos vêm com um plano pago.',
      fit: {
        unlimited: 'Seu plano não tem limite de vídeos com IA.',
        fits: 'Cerca de {n} vídeos com IA por mês. Você tem {left} neste período: dá.',
        short: 'Cerca de {n} vídeos com IA por mês, mas você tem {left} neste período: ela pausa depois de {episodes} episódios e avisamos por e-mail.',
        none: 'Você não tem vídeos com IA neste período: a série espera até renovarem.',
        upgrade: 'Ver planos',
      },
      card: {
        now: 'Agora',
        today: 'Hoje',
        tomorrow: 'Amanhã',
        week: 'Sua primeira semana',
        newIdea: 'Uma ideia nova',
        moreThisWeek: "+{n} nesta semana, cada um com uma ideia nova",
        promise: 'Nada é postado: cada episódio espera por você.',
        fillsIn: 'Isso se completa conforme você escolhe. Mostre os primeiros episódios para vê-los aqui.',
      },
      preview: {
        title: 'Seus primeiros episódios',
        hint: 'Escritos a partir da sua ideia em alguns segundos, antes de fazer qualquer coisa. Grátis, e você pode mudar qualquer um.',
        write: 'Mostre os primeiros episódios',
        writing: 'Escrevendo seus primeiros episódios…',
        rewrite: 'Reescrever',
        remove: 'Tirar',
        edit: 'Editar',
        add: 'Adicionar outro',
        again: 'Sua ideia mudou desde que foram escritos.',
        againButton: 'Escrever de novo',
        failed: 'Não deu para escrever agora. Tente de novo.',
        tooMany: 'Já foram prévias suficientes hoje. A série continua escrevendo os episódios conforme avança.',
        episode: 'Episódio {n}',
        more: 'Mais',
        less: 'Menos',
        save: 'Salvar',
        cancel: 'Cancelar',
        titleLabel: 'Título do episódio',
        ideaLabel: 'Sobre o que é o episódio',
        needTopic: 'Primeiro descreva sua série (uma ou duas frases).',
      },
    },
    review: {
      hint: "Assista, diga o que achou, e salve ou poste.",
      watch: 'Assistir o episódio {n}',
      exporting: 'Está sendo exportado: toca aqui assim que ficar pronto.',
      notExported: 'Este ainda não foi exportado. Abra para assistir, mudar e exportar.',
      feel: 'O que achou?',
      feelHint: 'As próximas ideias puxam para os episódios que você curte.',
      post: 'Postar',
      openEditor: 'Abrir no editor',
      redo: 'Fazer este episódio de novo',
      redoTitle: 'Fazer o episódio {n} de novo?',
      redoText: 'Uma versão nova fica no lugar dele, com o mesmo número. Este vídeo e o arquivo dele são substituídos. Usa um dos vídeos do seu plano.',
      redoKeep: 'Manter este',
      redoStarted: 'O episódio {n} está sendo feito de novo. Ele aparece aqui quando estiver pronto.',
      redoFailed: 'Não deu para fazer de novo. Tente daqui a pouco.',
      redoLimit: 'Seu plano não tem mais vídeos este mês.',
      upNext: 'A seguir:',
      makeNext: 'Fazer agora',
      madeNext: 'Está sendo feito. Aparece no cartão da série, e o e-mail avisa quando estiver pronto.',
      madeNextFailed: 'Não deu para começar. Tente pelo cartão da série.',
      previous: 'Anterior',
      next: 'Próximo',
      of: '{i} de {total}',
    },
    note: {
      setsLook: 'As legendas e a música que você escolher aqui viram o visual da série: os próximos episódios começam com eles.',
      wearsLook: 'Ele começa com o visual da série. Mude aqui as legendas ou a música e os próximos episódios seguem.',
      episode: 'Episódio {n} de {name}',
      seeSeries: 'Ver a série',
    },
    makeItOne: 'Transforme em série: um vídeo novo como este em um horário',
    hero: {
      new: 'Nova série',
      start: 'Comece sua primeira série',
    },
    creator: {
      heroHint: 'Esta série gira em torno de um herói. Crie ele aqui e ele fica igual em cada episódio.',
      steps: 'Passos',
      untitled: 'Sua série',
      summaryLabel: 'Resumo',
    },
    card: {
      posted: '{n} postados',
      cost: 'Cada episódio usa 1 dos seus {n} vídeos de IA restantes',
      waiting: '{n} para revisar',
      makeOne: 'Fazer um episódio agora',
      review: "Revisar episódios",
      making: 'Escrevendo a ideia…',
      more: 'Mais',
      makeThree: 'Fazer 3 episódios agora',
      edit: 'Editar série',
    },
    made: {
      started: "Fazendo {n} agora. Cada um fica pronto para assistir em alguns minutos.",
      stopped: {
        out_of_videos: 'Seu plano não tem mais vídeos de IA neste período.',
        out_of_minutes: 'Seu plano não tem mais minutos neste período.',
        longer_than_plan: 'Seu plano faz vídeos de 30 segundos: encurte os episódios ou faça upgrade.',
        already_making: 'Os episódios já estão começando. Espere um momento.',
        other: 'Não conseguimos começar um episódio. Tente de novo.',
      },
      upgrade: 'Ver planos',
    },
    starters: {
      title: 'Comece com uma ideia',
      more: 'Ideias para sua próxima série',
      hint: 'Um toque preenche tudo. Mude o que quiser.',
      withCast: 'Com um herói',
      legends: { title: 'Lendas do folclore brasileiro', topic: 'Lendas do folclore brasileiro contadas para adultos: Saci, Curupira, Iara, Boitatá, Mula sem Cabeça e muitas mais. Uma lenda por episódio, fiel a como ela é contada de verdade.' },
      hero: { title: 'Aventuras para dormir', topic: 'Aventuras tranquilas para dormir, para crianças de 4 a 8 anos, com o mesmo pequeno herói. Em cada episódio um lugar novo e uma pequena lição sobre bondade ou coragem.' },
      top5: { title: 'Top 5 curiosidades', topic: 'Contagens regressivas de 5 fatos surpreendentes e verdadeiros sobre ciência e natureza. Um tema por episódio, até chegar ao mais surpreendente.' },
      pov: { title: 'POV histórico', topic: 'Você está lá: um dia da história visto pelos olhos de uma pessoa comum, na segunda pessoa. Fiel à época, uma época por episódio.' },
      quiz: { title: 'Hora do quiz', topic: 'Quizzes para jogar enquanto assiste: perguntas de conhecimentos gerais cada vez mais difíceis, com a resposta depois de uma pausa curta.' },
      chat: { title: 'Histórias por chat', topic: 'Histórias curtas contadas numa conversa de chat entre dois amigos, com uma reviravolta no final. Situações do dia a dia, nunca pessoas reais.' },
      scary: { title: 'Histórias de terror', topic: 'Histórias curtas de terror para contar à noite: casas assombradas, vizinhos estranhos, coisas vistas em estradas vazias. Histórias originais, uma por episódio, com uma reviravolta no final.' },
      facts: { title: 'Você sabia?', topic: 'Um fato surpreendente e verdadeiro por episódio sobre história, natureza ou coisas do dia a dia, explicado para não esquecer. Só fatos reais e verificáveis.' },
      fables: { title: 'Pequenas lições', topic: 'Fábulas curtas para crianças de 4 a 8 anos: um bicho aprende algo sobre dividir, paciência ou honestidade. Carinhosas e engraçadas, com uma lição clara no final.' },
      stoic: { title: 'Sabedoria estoica', topic: 'Uma ideia dos estoicos (Marco Aurélio, Sêneca, Epicteto) por episódio, contada a partir de um momento da vida deles e do que ela significa para um dia como hoje.' },
      love: { title: 'Histórias de amor', topic: 'Histórias de amor curtas e delicadas: primeiros encontros, amores à distância, segundas chances. Pessoas comuns, nunca reais, cada uma com um momento que fica com você.' },
      whatif: { title: 'E se…?', topic: 'E se a Lua sumisse, a gente parasse de dormir ou a internet caísse por um ano? Uma pergunta por episódio, respondida com ciência de verdade, passo a passo.' },
    },
    ideaFirst: {
      title: 'Episódio {n}: a ideia',
      remakeTitle: 'Episódio {n} de novo: a ideia dele',
      newIdea: 'Escrever uma ideia nova',
      hint: 'É disso que o episódio vai ser feito. Mude o que quiser e depois faça. Usa um dos vídeos do seu plano.',
      writing: 'Escrevendo a ideia…',
      draftFailed: 'Não deu para escrever a ideia. Feche e tente de novo.',
      make: 'Fazer o episódio {n}',
      remake: 'Fazer o episódio {n} de novo',
      failed: 'Não deu para fazer. Tente daqui a pouco.',
    },
    upNext: {
      none: "A próxima ideia é escrita quando chegar a hora do episódio. Adicione a sua para escolher.",
      noneWhen: "Próximo episódio {when}: a ideia é escrita nessa hora.",
      all: 'Todas as ideias ({n})',
      title: 'A seguir',
      hint: 'As próximas ideias, antes de fazer qualquer coisa. Mude, troque ou adicione as suas.',
      error: 'Não conseguimos carregar as próximas ideias. Atualize para tentar de novo.',
      writing: 'Escrevendo as próximas ideias…',
      yours: 'Sua ideia',
      first: 'A próxima',
      untitled: 'Ideia sem título',
      make: 'Fazer agora',
      edit: 'Editar esta ideia',
      swap: 'Trocar por outra ideia',
      earlier: 'Mover para antes',
      remove: 'Tirar esta ideia',
      add: 'Adicionar sua própria ideia',
      save: 'Salvar',
      cancel: 'Cancelar',
      titleLabel: 'Título',
      titlePlaceholder: 'Um título provisório',
      ideaLabel: 'A ideia',
      ideaPlaceholder: 'Sobre o que é este episódio e o ângulo dele',
    },
    continuity: {
      label: 'Episódios',
      standalone: 'Cada um por si',
      standaloneHint: 'Uma história, curiosidade ou ângulo novo a cada vez.',
      continuing: 'Uma história que continua',
      continuingHint: 'Cada episódio continua de onde o anterior parou.',
    },
    notes: {
      label: 'Notas da série (opcional)',
      hint: 'Todo episódio segue essas notas: tom, público, o que fazer sempre e o que nunca.',
      placeholder: 'Para crianças de 6 a 9 anos. Leve e engraçado, nunca assustador. Sempre termine com um gesto gentil.',
    },
    feedback: {
      up: 'Mais assim',
      down: 'Menos assim',
    },
    nudgeTitle: 'Está fazendo uma série?',
    nudgeBody: 'Parece uma parte de várias. Uma série escreve e faz os próximos episódios para você, no ritmo que escolher, com este estilo e esta voz; você revisa cada um antes de postar.',
  },
  fairBilling: {
    eyebrow: 'Cobrança justa',
    title: 'Você paga pelo que recebe. Nada mais.',
    failTitle: 'Falhas são por nossa conta',
    failBody: 'Um vídeo, clipe ou renderização que falha não custa nada, e refazer uma imagem ou uma voz dentro de um vídeo nunca custa outro vídeo.',
    rollTitle: 'O que você não usa passa para o mês seguinte',
    rollBody: 'Os minutos e vídeos de IA que você não usa neste mês somam no próximo, até o equivalente a um mês.',
    keepTitle: 'Seus projetos continuam seus',
    keepBody: 'Se você cancelar ou mudar de plano, seus projetos e exportações ficam na sua conta por pelo menos 90 dias.',
    note: 'O acúmulo vale no Pro. Os planos anuais recebem seus minutos e vídeos todo mês.',
  },
  pricing: {
    badge: 'Mais de 10.000 criadores',
    title: 'Preços simples e transparentes',
    subtitle: 'Escolha o plano certo para você. Comece grátis e faça upgrade quando quiser.',
    monthly: 'Mensal',
    annual: 'Anual',
    cancelAnytime: 'Cancele quando quiser',
    localApprox: '≈ {amount} EGP',
    billedInDollars: 'Cobrado em dólares. Seu banco converte para libras egípcias e pode cobrar uma pequena taxa.',
    securePayments: 'Pagamento seguro com Stripe',
    noCard: 'O plano gratuito não pede cartão',
    grandfatheredTitle: 'Você tem um plano antigo',
    grandfatheredBody: 'Este plano não está mais disponível para novos clientes. Você pode manter seu preço e seus limites ou mudar para o novo plano Pro.',
    manage: 'Gerenciar minha assinatura',
    currentPlan: 'Seu plano atual',
    currentPlanButton: 'Plano atual',
    freeName: 'Grátis',
    freeDescription: "Uma hora de clipes com IA por mês, com legendas e reenquadramento, grátis e sem cartão. Os vídeos com IA vêm com o Pro ou com um pacote.",
    forever: '/para sempre',
    freeHours: '{n} hora de processamento de vídeo por mês',
    clippingTools: 'Cortes com IA, legendas automáticas, reenquadramento',
    repromptOne: '{n} nova busca de cortes por vídeo',
    editorRendering: 'Exportação pelo editor',
    freeAgent: "Vídeos com IA: {n} vídeos Pro por {price}, pagamento único",
    proSeason: '+{n} vídeos com IA extras neste outubro',
    promoTitle: 'Oferta de outubro: {n} vídeos com IA extras no Pro',
    promoText: 'Assine este mês e ganhe na hora {n} vídeos com IA, além dos do seu plano. Eles não expiram.',
    promoRibbon: 'Oferta de outubro · +{n} vídeos com IA',
    imageRegens: '{n} imagens regeneradas por vídeo',
    noImageEdits: 'Sem edição de imagens',
    noAnimations: 'Sem animar imagens',
    noVoiceRegens: 'Sem regenerar a voz',
    proOnly: 'Só no Pro',
    noWatermarks: 'Exportações sem marca d’água',
    editorAccess: 'Acesso ao editor de vídeo',
    prioritySupport: 'Suporte prioritário por e-mail',
    freeCta: 'Comece grátis',
    proName: 'Pro',
    packageSummary: '{hours} h + {videos} vídeos',
    scale: 'Cresça no seu ritmo',
    proHintSubscriber: 'Arraste o controle para somar horas e vídeos de IA, ou para reduzir.',
    proHint: "Escolha quanto você precisa. Cada pacote soma horas, vídeos com IA e mais tentativas; mude quando quiser.",
    hoursUnit: 'horas',
    hoursSuffix: 'de processamento de vídeo por mês',
    repromptMany: '{n} novas buscas de cortes',
    perVideo: 'por vídeo',
    agentVideosUnit: 'vídeos do Agente de IA',
    perMonth: 'por mês',
    imageRegensBold: '{n} imagens regeneradas',
    imageEditsBold: '{n} edições de imagem',
    animationsBold: '{n} animações de imagem em vídeo',
    voiceRegensBold: '{n} regenerações de voz',
    deltaUp: '+{hours} h de processamento • +{videos} vídeos de IA',
    deltaDown: '-{hours} h de processamento • -{videos} vídeos de IA',
    openingPortal: 'Abrindo o portal...',
    upgradePlan: 'Fazer upgrade',
    downgradePlan: 'Reduzir plano',
    processing: 'Processando...',
    proCta: "Começar com o Pro",
    proCtaMany: "Começar com o Pro: {videos} vídeos com IA, {amount} hoje",
    proCtaYear: "Começar com o Pro: {amount} hoje, pago anualmente",
    proFootnote: 'Cancele quando quiser. Aumente ou diminua no seu ritmo.',
    authTitle: 'Crie sua conta',
    authBody: 'Cadastre-se para assinar um plano.',
    checkoutError: 'Erro no pagamento',
    checkoutErrorBody: 'Não foi possível iniciar o pagamento. Tente novamente.',
    portalError: 'Erro no portal',
    portalErrorBody: 'Não foi possível abrir o gerenciamento da assinatura. Tente novamente.',
    slider: {
      perYear: 'ano',
      perMonth: 'mês',
      perMonthEq: "{price} por mês, pagando por ano",
      saveYear: "Você economiza {amount} por ano",
      processing: '{n} h de processamento',
      aiVideos: '{n} vídeos de IA',
    },
    picker: {
      howMany: 'Quantos vídeos com IA por mês?',
      unit: 'vídeos',
      preset: '{n} vídeos por mês',
      fewer: 'Menos vídeos',
      more: 'Mais vídeos',
      firstMonth: 'no primeiro mês',
      then: 'depois {price} por mês',
    },
    annualSave: "Economize {n}%",
    rollOver: "O que não usar passa para o mês seguinte",
    howMuch: "De quanto você precisa?",
    moreThan: "Precisa de mais de {hours} horas por mês?",
    moreThanLink: "Fale com a gente",
    compare: {
      title: "Compare os planos",
      subtitle: "O que você recebe no Grátis e no Pro",
      features: "O que você recebe",
      free: "Grátis",
      pro: "Pro",
      freePrice: "{price} para sempre",
      proPrice: "a partir de {price} por mês",
      perVideo: "{n} por vídeo",
      perVideoRange: "{a}–{b} por vídeo",
      hours: "{n} h",
      hoursRange: "{a}–{b} h",
      range: "{a}–{b}",
      videosOnce: "Pacote: {n} por {price}",
      rows: {
        hours: "Processamento de vídeo por mês",
        hoursHint: "Clipes com IA, Legendas automáticas, Reenquadrar, exportações do editor",
        videos: "Vídeos com IA por mês",
        reprompts: "Novas buscas de clipes",
        redraws: "Imagens refeitas",
        edits: "Edições de imagem",
        animations: "Imagens animadas",
        voice: "Vozes refeitas",
        watermark: "Marca d'água",
        support: "Suporte",
      },
      watermarkFree: "Marca pequena do Clip-Short",
      supportFree: "Por e-mail",
      supportPro: "E-mail prioritário",
      yes: "Incluído",
      no: "Não incluído",
      bothTitle: "Nos dois planos",
      both: "Clipes com IA, Legendas automáticas, Reenquadrar, o editor completo, Séries e Personagens, exportações em 1080p, downloads e armazenamento na nuvem.",
      bundleNote: "O Pro vai de um pacote a dez. Cada pacote soma {hours} horas, {videos} vídeos com IA e a sua parte de tentativas.",
    },
    // Every way to pay in one dated table (components/PricingPage/AtAGlance.jsx)
    glance: {
      eyebrow: "Num relance",
      title: "Todas as formas de pagar, em uma tabela",
      plan: "Plano",
      includes: "O que inclui",
      free: "Grátis",
      freePrice: "{price} por mês",
      freeBody: "{minutes} minutos por mês de AI Clipping, legendas automáticas e reenquadramento, com uma pequena marca d’água, e o editor completo. Para criar a conta não precisa de cartão. Sem vídeos do Agente de IA.",
      pack: "Pacote de {n} vídeos Pro",
      once: "{price}, pagamento único",
      packBody: "{n} vídeos do Agente de IA feitos como no Pro, sem marca d’água. Sem assinatura.",
      clipPack: "Pacote de clipes",
      clipPackBody: "{minutes} minutos de AI Clipping, todos os clipes desses vídeos exportados sem marca d’água e {remixes} remixes. Sem assinatura.",
      pro: "Pro, mensal",
      proPrice: "{price} por mês por pacote",
      proBody: "Cada pacote dá {hours} horas de processamento de vídeo e {videos} vídeos do Agente de IA por mês, sem marca d’água. Escolha de 1 a {max} pacotes e cancele quando quiser.",
      yearly: "Pro, anual",
      yearlyPrice: "{price} por ano por pacote",
      yearlyBody: "{perMonth} por mês. As {hours} horas e os {videos} vídeos com IA de cada pacote chegam todo mês do ano.",
      fair: "Cobrança justa",
      fairBody: "Um vídeo, clipe ou renderização que falha não custa nada. No Pro, os minutos e vídeos com IA que você não usa somam no período seguinte, até o equivalente a um período. Se você cancelar ou mudar de plano, seus projetos ficam na sua conta por pelo menos 90 dias.",
    },
    faq: {
      title: "Perguntas sobre os preços",
      subtitle: "Cobrança, o que conta e o que você pode fazer com os vídeos.",
      more: "Ficou alguma dúvida?",
      contact: "Escreva para support@clip-short.com",
      items: [
        {
          q: "Como funciona o preço do Pro?",
          a: "O Pro é vendido em pacotes. Um pacote são {hours} horas de processamento de vídeo e {videos} vídeos com IA por mês, por {monthly} por mês ou {yearly} por ano ({yearlyPerMonth} por mês, {saving} a menos do que pagar mês a mês). Arraste o controle para levar até dez; o preço e tudo o que você recebe crescem juntos, e você muda quando quiser na sua conta.",
        },
        {
          q: "O que conta como tempo de processamento?",
          a: "A duração do vídeo que você entrega a uma ferramenta. Um vídeo de 60 minutos custa 60 minutos, tire você 5 clipes ou 20: Clipes com IA, Legendas automáticas e Reenquadrar contam o vídeo original, e o editor conta o vídeo final. Um trabalho que falha não custa nada.",
        },
        {
          q: "O que é um vídeo com IA?",
          a: "Um vídeo pronto a partir de uma ideia que você escreve: o roteiro, imagens no estilo que escolher, um narrador, legendas e música da nossa própria biblioteca. Você pode refazer ou editar qualquer imagem, animá-la, refazer a voz e postar o resultado como está. Uma série faz um no horário marcado, e cada episódio conta como um vídeo com IA.",
        },
        {
          q: "Os minutos e vídeos que não uso passam para o mês seguinte?",
          a: "No Pro, sim. O que você não usa em um mês passa para o seguinte, até o equivalente a um mês. Os planos anuais recebem seus minutos e vídeos todo mês e passam adiante do mesmo jeito.",
        },
        {
          q: "Os vídeos têm marca d'água?",
          a: "As exportações grátis levam uma marca pequena do Clip-Short. As do Pro saem limpas, e são suas: poste e use para clientes; se um vídeo é monetizado, quem decide é cada plataforma.",
        },
        {
          q: "Posso mudar ou cancelar meu plano?",
          a: "Quando quiser. Adicionar pacotes vale na hora e você paga a diferença pelo resto do período; tirar pacotes vale na próxima renovação; ao cancelar, você mantém o Pro até o fim do que pagou. Seus projetos ficam na sua conta de qualquer jeito.",
        },
        {
          q: "E se o Pro não for para mim?",
          a: "Escreva para support@clip-short.com em até 14 dias do seu primeiro pagamento e devolvemos tudo, sem perguntas.",
        },
        {
          q: "Como eu pago, e em qual moeda?",
          a: "Com cartão, no checkout do Stripe; o número do seu cartão nunca chega até nós. No Brasil, o pacote de vídeos Pro também pode ser pago com Pix, e o checkout mostra as outras formas que o Stripe aceita no seu país. Boleto não está disponível por enquanto. Você é cobrado na sua moeda onde o Stripe consegue cobrar (euros na Europa, pesos no México, reais no Brasil e assim por diante) e em dólares no resto, que o seu banco converte.",
        },
      ],
    },
  },

  suggest: {
    text: 'Este site também está em português.',
    link: 'Ver em português',
    close: 'Fechar',
  },

  season: {
    label: 'Halloween e Dia do Saci',
    message: 'Halloween e Dia do Saci: crie seu vídeo de temporada em minutos.',
    cta: 'Ver ideias',
    paidOffer: 'Oferta de outubro: assine este mês e ganhe na hora {videos} vídeos com IA, além dos do seu plano.',
    paidOfferShort: 'Out: +{videos} vídeos com o Pro',
    paidCta: 'Ver o Pro',
    close: 'Fechar',
  },

  // Sharing a video earns a video, for both people (growth/referral.js)
  videoFeedback: {
    title: 'Como ficou este vídeo?',
    body: 'Conte o que achou e por quê. Lemos cada resposta e usamos para melhorar os próximos vídeos.',
    good: 'Bom',
    bad: 'Ruim',
    thanks: 'Obrigado! Lemos cada resposta.',
    askGood: 'Do que você mais gostou?',
    askBad: 'O que deu errado? Conte pra gente consertar.',
    send: 'Enviar',
    change: 'Mudar',
    later: 'Agora não',
    failed: 'Não foi enviado. Tente de novo.',
  },
  referral: {
    kicker: "Um vídeo Pro para você",
    offer: "Compartilhe este vídeo. Quando um amigo que você trouxer comprar um pacote ou o Pro, você ganha um vídeo Pro.",
    action: 'Compartilhar e ganhar um vídeo',
    progress: '{joined} amigos entraram · {earned} de {cap} vídeos ganhos este mês',
    wallAction: "Compartilhe um vídeo e ganhe um Pro",
    exportFirst: "Primeiro exporte o seu vídeo. Depois compartilhe: quando um amigo que você trouxer comprar um pacote ou o Pro, você ganha um vídeo Pro.",
    inviteTitle: "Seu link de convite",
    inviteBody: "Ou compartilhe seu próprio link: na bio, num comentário ou num grupo. O mesmo prêmio: um vídeo Pro para cada amigo que comprar um pacote ou o Pro, até {cap} por mês.",
    inviteCopy: "Copiar link de convite",
    inviteCopied: "Link copiado",
    inviteWhatsapp: "Enviar meu link no WhatsApp",
    inviteMessage: "Eu faço meus vídeos com IA na Clip-Short: roteiro, imagens, voz e legendas a partir de uma ideia. Experimente aqui 👉",
  },
  share: {
    button: 'Compartilhar',
    title: 'Compartilhe seu vídeo',
    body: 'Qualquer pessoa com o link pode assistir e criar um igual. Você pode parar de compartilhar quando quiser.',
    whatsapp: 'Compartilhar no WhatsApp',
    facebook: 'Compartilhar no Facebook',
    copy: 'Copiar link',
    copied: 'Link copiado',
    stop: 'Parar de compartilhar',
    stopped: 'Compartilhamento desativado: o link não funciona mais.',
    error: 'Não foi possível mudar o compartilhamento. Tente novamente.',
    message: "Olha o vídeo que eu fiz com IA. Faça o seu aqui 👉",
    linkTitle: 'Link público',
    dialogTitle: 'Compartilhar este vídeo',
  },
  // The public gallery switch (components/share/GallerySwitch.jsx, api routes/gallery.py)
  gallery: {
    title: "Galeria pública",
    body: "Mostre este vídeo na galeria pública da Clip-Short, onde qualquer pessoa pode encontrá-lo e assistir. Desative quando quiser e a página dele some.",
    remove: "Tirar",
    switchLabel: "Mostrar na galeria pública",
    pending: "Aguardando revisão. Ele aparece na galeria quando for aprovado.",
    public: "Na galeria",
    view: "Ver a página",
    rejected: "Não aprovado: {reason}",
    rejectedNoReason: "Não aprovado para a galeria.",
    error: "Não conseguimos mudar isso. Tente de novo.",
    captionLabel: "Sua legenda",
    captionHelp: "Opcional: algumas palavras para sua publicação na galeria, embaixo do vídeo. Ela aparece depois da nossa revisão, e você pode mudar ou tirar quando quiser. Sem links.",
    captionPlaceholder: "Conte algo sobre este vídeo…",
    captionSave: "Salvar legenda",
    captionRemove: "Tirar legenda",
    captionWaiting: "Legenda aguardando revisão",
    captionShown: "Legenda visível na publicação",
    refused: {
      caption_has_a_link: "Sem links, endereços de sites ou e-mails na legenda.",
      caption_too_long: "Até 500 caracteres.",
      not_exported: "Exporte o vídeo primeiro.",
      not_finished: "O vídeo ainda não está pronto.",
      gallery_rejected: "Este vídeo não foi aprovado. Mude o vídeo e exporte de novo para pedir outra vez.",
    },
  },
  sharedVideo: {
    clipMadeWith: "Recortado com Clip-Short",
    clipOwn: "Recorte seu próprio vídeo",
    clipPitch: "Cole um link do YouTube e receba os melhores momentos como clipes verticais, enquadrados e com legendas, em minutos.",
    clipMessage: "Olha este clipe 👉",
    bothGet: "Escreva a sua ideia e receba um vídeo como este: narrado, ilustrado e legendado.",
    madeWith: 'Feito com o Clip-Short',
    idea: 'A ideia:',
    makeOne: 'Criar um igual',
    createFree: "Crie seu vídeo",
    pitch: 'Este vídeo saiu de uma única ideia. Escreva a sua e o Agente de IA faz o roteiro, as imagens, a narração e as legendas.',
    copied: 'Link copiado',
    notFoundTitle: 'Este vídeo não está disponível',
    notFoundText: 'Quem criou pode ter parado de compartilhar. Você pode criar o seu em poucos minutos.',
    loading: 'Carregando...',
    whatsapp: 'WhatsApp',
    message: 'Olha este vídeo feito com IA 👉',
  },

  auth: {
    checkStalled: { title: 'O cadastro travou numa verificação de segurança', body: 'A verificação que barra robôs não carregou, então Continuar não avança. Use Continuar com o Google, acima, ou recarregue a página. Uma VPN ou um bloqueador de anúncios podem impedi-la.', google: 'Continuar com o Google', reload: 'Recarregar a página' },
    loginTitle: 'Entre no Clip‑Short',
    loginSubtitle: 'Acesse seus projetos e continue criando.',
    noAccount: 'Não tem conta?',
    signUp: 'Cadastre-se grátis',
    signupTitle: 'Crie sua conta no Clip‑Short',
    unavailableTitle: 'O Clip‑Short não está disponível no seu país',
    unavailableBody: 'Por enquanto, você não pode se cadastrar nem entrar daqui.',
    signupSubtitle: 'Comece em poucos segundos.',
    haveAccount: 'Já tem conta?',
    signIn: 'Entrar',
    loginError: 'Erro ao entrar',
    signupError: 'Erro no cadastro',
    authFailed: 'Não foi possível entrar. Tente novamente.',
    serverError: 'Ocorreu um erro no servidor. Tente mais tarde.',
    loadingAccount: 'Carregando sua conta',
    accountErrorTitle: 'Não conseguimos carregar sua conta',
    accountErrorText: 'Você está conectado, mas nosso servidor não respondeu. Costuma voltar em alguns segundos.',
    tryAgain: 'Tentar de novo',
    signOut: 'Sair',
    slowText: 'O login está demorando mais que o normal. Pode ser uma conexão lenta.',
    reload: 'Recarregar a página',
    ideaTitle: 'Seu vídeo está a um passo',
    ideaSaved: 'Sua ideia está salva',
    ideaNext: "Crie sua conta e sua ideia te espera na próxima página, pronta para virar vídeo.",
    signupValue: "1 hora de clipes com IA por mês, com legendas e reenquadramento, grátis e sem cartão.",
    signupSeoTitle: 'Crie sua conta grátis na Clip-Short',
    signupSeoDescription: "Uma hora de clipes com IA por mês, com legendas e reenquadramento, sem cartão. Cadastre-se com Google ou e-mail.",
    loginSeoTitle: 'Entrar na Clip-Short',
    loginSeoDescription: 'Seus projetos, clipes e vídeos com IA. Entre com Google ou e-mail.',
  },

  showcase: {
    sourceVideo: 'Vídeo original',
    aiAnalysis: 'Análise com IA',
    analyzeVideo: 'Analisar vídeo',
    clipsReady: 'Clipes prontos para cada plataforma',
    tagVoice: 'Voz',
    tagSentiment: 'Emoção',
    tagMotion: 'Movimento',
    feedFollowing: 'Seguindo',
    feedForYou: 'Para você',
  },
  // The free video's worst picture redrawn by Pro (components/AIAgent/ProPreview.jsx)
  proPreview: {
    eyebrow: "Pro",
    title: "Seu vídeo, em qualidade Pro",
    body: "Desenhamos de novo uma imagem do seu vídeo com o nosso melhor modelo. Arraste para comparar.",
    // the default since 2026-10-13: one picture drawn again by rule, no defect named
    titleShowcase: "Com o Pro, todas as imagens ficam assim",
    bodyShowcase: "Desenhamos de novo uma imagem do seu vídeo com o nosso melhor modelo. Arraste para comparar. O Pro faz o vídeo inteiro com essa qualidade.",
    proShowcase: "Pro: muito mais qualidade e bem menos erros",
    ownVoice: "Narre com a sua própria voz ou troque a voz quando quiser",
    titleGallery: "Dê vida aos seus personagens com o Pro",
    bodyGallery: "Cada imagem feita com o nosso melhor modelo, e a que você escolher vira um clipe com movimento.",
    galleryNote: "Feito com o Pro: um personagem em três cenas, depois animado",
    galleryAlt: "Um personagem desenhado e animado com o Pro",
    chipGallery: "Veja o que o Pro faz",
    animatedBadge: "Animado",
    whatProGallery: "O que o Pro te dá",
    allPicturesGallery: "Todas as imagens dos seus vídeos com o nosso melhor modelo",
    free: "Grátis",
    pro: "Pro",
    problemFree: "Grátis: {what}",
    proDrawn: "Pro: desenhada de novo com o nosso melhor modelo",
    proFixed: "Pro: desenhada certa",
    proBetter: "Pro: mais nítida e mais realista",
    allPictures: "As {n} imagens deste vídeo com esta qualidade",
    allPicturesNoCount: "Cada imagem do seu vídeo com esta qualidade",
    later: "Agora não",
    compare: "Compare a imagem grátis e a imagem Pro",
    chip: "Veja uma imagem do seu vídeo desenhada com o Pro",
    altFree: "Sua imagem, desenhada no plano grátis",
    altPro: "A mesma imagem, desenhada pelo Pro",
    kindText: "Texto sem sentido",
    kindExtra: "Um personagem a mais",
    kindWrong: "O personagem errado",
    kindMissing: "Falta um personagem",
    kindAnatomy: "Uma mão ou um rosto parece errado",
    kindQuality: "Desfocada e com pouco detalhe",
    whatPro: "O que o Pro faz por este vídeo",
    cleanAndLong: "Sem marca d’água, e vídeos de até 10 minutos",
    firstMonth: "no seu primeiro mês",
    off50: "−50%",
    thenMonthly: "depois {price} por mês · cancele quando quiser",
    aMonth: "por mês",
    cancelAnytime: "Cancele quando quiser",
  },
  checkoutWaiting: {
    label: 'Um pagamento que você deixou',
    titlePro: 'Seu upgrade para o Pro está esperando',
    titlePack: 'Seus 3 vídeos com IA estão esperando',
    textPro: '{price} hoje. Continue de onde parou.',
    textPack: '{price}, sem assinatura. Continue de onde parou.',
    continue: 'Continuar',
    question: 'O que fez você parar?',
    answers: {
      too_expensive: 'Caro demais',
      no_subscription: 'Não quero assinatura',
      payment_problem: 'Um problema no pagamento',
      just_looking: 'Só estava olhando',
    },
    thanks: 'Obrigado, isso nos ajuda.',
    close: 'Fechar',
    packAddedTitle: "{n} vídeos Pro adicionados",
    packAddedText: "Já estão na sua conta: até 3 minutos cada, sem marca d’água. Use quando quiser.",
  },
  // A new account's first video, sold at Generate (components/upgrade/FirstVideoOffer.jsx)
  firstVideo: {
    title: "Seu vídeo está pronto para ser criado",
    proBadge: "Melhor preço",
    proName: "Pro",
    perMonth: "por mês",
    proVideos: "{n} vídeos com IA por mês",
    proClipping: "{n} horas de cortes com IA por mês",
    noWatermark: "Sem marca d’água",
    cancelAnytime: "Cancele quando quiser",
    proCta: "Assinar o Pro e criar meu vídeo",
    packBadge: "Sem assinatura",
    packName: "{n} vídeos Pro",
    once: "pagamento único",
    packLength: "Até {n} minutos cada",
    noSubscription: "Não renova, nada para cancelar",
    packCta: "Comprar por {price} e criar meu vídeo",
    startsAfter: "Seu vídeo começa sozinho assim que você pagar.",
    yourIdea: "Sua ideia",
    showcaseTitle: "Feito com o Pro",
    showcaseNote: "Exemplos de outras ideias",
    showcaseAnimated: "Animado",
    showcase_workshop: "Na oficina",
    showcase_balloon: "De balão",
    showcase_stars: "Sob as estrelas",
    pickAnother: "Toque em outro para assistir",
    sound: "Som",
    soundOn: "Com som",
    playExample: "Reproduzir {name}",
    playWithSound: "Reproduzir {name} com som",
    muteExample: "Silenciar {name}",
    perVideo: "≈ {price} por vídeo",
    secure: "Pagamento seguro pela Stripe",
    changeIdea: "Mudar minha ideia",
    afterProLeft: "Prefere sem assinatura? {n} vídeos Pro por {pack}, pagamento único",
    freeTools: "Agora não: crie clipes grátis a partir de um vídeo",
    starting: "Pagamento recebido. Seu vídeo está começando…",
    startingSlow: "Seu pagamento ainda está sendo confirmado. Tente de novo em um minuto.",
  },
  // The Remix offer: a remix asked for with no video left (components/Remix/RemixOffer.jsx)
  remixOffer: {
    title: "Seu remix está a um passo",
    starts: "Escolha um plano e seu remix começa sozinho. Nada para escolher de novo.",
    yours: "Seu remix",
    showcaseNote: "Vídeos feitos com o Pro, sem marca d’água. Toque em um para assistir.",
    showcaseNoteRemix: "Remixes feitos com o Remix, de clipes de domínio público. Toque em um para assistir.",
    proRemixes: "{n} vídeos de IA ou remixes por mês",
    proCta: "Assinar o Pro e fazer meu remix",
    back: "Voltar ao meu remix",
    starting: "Pagamento recebido. Começando seu remix…",
    slow: "Seu pagamento ainda está a caminho. Seu remix começa assim que ele chegar.",
    failed: "Seu remix não começou: {reason}",
  },
  // The tools' watermark offer (components/upgrade/WatermarkOffer.jsx, RemoveWatermarkButton.jsx)
  watermarkOffer: {
    button: "Tirar a marca d’água",
    pro: "PRO",
    title: "Exporte sem marca d’água",
    body: "Com o Pro, todo clipe, vídeo legendado e vídeo redimensionado que você exporta sai limpo. Assine o Pro e exporte de novo.",
    markGone: "Nossa marca sai de tudo o que você exporta",
    showcaseNote: "O Pro também faz vídeos completos como estes. Toque em um para assistir",
    monthlyBadge: "O mais escolhido",
    monthlyName: "Pro, mensal",
    clean: "Sem marca d’água em nada do que você exporta",
    hours: "{n} horas por mês de cortes, legendas e redimensionamento",
    videos: "{n} vídeos com IA por mês, como estes",
    monthlyCta: "Assinar o Pro e tirar a marca",
    yearlyBadge: "{n} meses grátis",
    yearlyName: "Pro, anual",
    perYear: "por ano",
    yearlyMonthly: "≈ {price} por mês, pago uma vez por ano",
    yearlyCta: "Pagar o ano",
    keep: "Manter a marca",
  },
  clipExports: {
    title: "Exporte este clipe",
    body: "No plano grátis, seu clipe sai com a marca d’água da Clip-Short. O Pro exporta todos os clipes sem ela, e o Remix transforma um clipe em um vídeo novo como estes.",
    lockedTitle: "Você já exportou {n} clipes grátis deste vídeo",
    lockedBody: "O Pro exporta todos os clipes de todos os seus vídeos sem marca d’água, e o Remix transforma um clipe em um vídeo novo como estes.",
    freeName: "Plano grátis",
    freeCta: "Exportar com marca d’água",
    freeNote: "Com a marca d’água da Clip-Short",
    left: "Exportações grátis restantes neste vídeo: {left} de {limit}",
    every: "Todos os clipes de todos os vídeos, sem marca d’água",
    remix: "Remix: um clipe transformado em um vídeo novo",
    showcaseNote: "Feitos com o Remix, cada um a partir de um clipe. Toque em um para assistir",
    madeWith: "Feito com o Remix",
    lockedHint: "O Pro exporta todos os clipes",
    cta: "Assine o Pro e exporte todos",
    packName: "Pacote de clipes",
    packOnce: "Pagamento único, nunca expira",
    packMinutes: "{n} minutos de AI Clipping",
    packClean: "Todos os clipes desses vídeos, sem marca d’água",
    packRemixes: "{n} remixes",
    packCta: "Comprar o pacote de clipes",
    unlockTitle: "Desbloqueie este vídeo com seu pacote de clipes",
    unlockNote: "Usa {n} dos {m} minutos do seu pacote. Depois, todos os clipes são exportados sem marca d’água.",
    unlockCta: "Desbloquear este vídeo",
    unlockShort: "Seu pacote de clipes não tem mais os minutos deste vídeo",
    again: "Exportar de novo sem marca d’água",
    unlocked: "Seu pacote de clipes está pronto. Todos os clipes deste vídeo são exportados sem marca d’água.",
    packLeft: "Pacote de clipes: {m} min · {r} remixes",
    notNow: "Agora não",
  },
  upgrade: {
    subscriberBody: 'Você está no Pro e já usou os vídeos deste mês. Adicione um pacote ao seu plano e continue hoje mesmo.',
    subscriberMinutesBody: 'Você está no Pro e ficou sem minutos. Adicione um pacote ao seu plano e continue hoje mesmo.',
    bundleName: 'Mais um pacote: {price} por mês',
    addToPlan: 'Adicionar ao meu plano',
    videosTitle: 'Você já usou seus vídeos com IA deste mês',
    freeVideosTitle: "Você não tem mais vídeos com IA",
    minutesTitle: 'Seus minutos de processamento acabaram',
    body: 'Assine o Pro e continue criando hoje mesmo.',
    bodyRenews: 'Seu plano gratuito renova em {date}. Assine o Pro e continue hoje mesmo.',
    minutesBody: 'Este vídeo precisa de {needed} minutos e restam {left}. Assine o Pro e continue hoje mesmo.',
    planName: 'Pro: {price} por mês',
    planVideos: '{n} vídeos com IA por mês',
    planHours: '{n} horas de processamento de vídeo por mês',
    cta: 'Assinar o Pro por {price} por mês',
    pack: "Precisa só de alguns? {n} vídeos Pro por {price}: até 3 minutos, sem marca d’água e sem assinatura",
    ctaLoading: 'Abrindo o pagamento…',
    secondary: 'Ver todos os planos',
    coupon: 'Metade do preço no primeiro mês',
    planNameIntro: 'Pro: {first} no primeiro mês, depois {price} por mês',
    ctaIntro: 'Assinar o Pro por {first} no primeiro mês',
    thenPrice: 'Metade do preço no primeiro mês, depois {price} por mês. Cancele quando quiser.',
    firstMinutes: 'Ou faça clipes com os primeiros {n} minutos, grátis',
    watermarkTitle: 'Exporte seu vídeo sem marca d’água',
    watermarkBody: 'No Pro, todos os seus vídeos e clipes saem limpos. Assine o Pro e exporte este de novo.',
    animateTitle: 'Anime suas imagens com o Pro',
    animateBody: 'Imagens paradas viram clipes com movimento. O Pro inclui {n} animações por vídeo.',
    editTitle: 'Edite imagens com IA no Pro',
    editBody: 'Descreva a mudança e a imagem é desenhada de novo. O Pro inclui {n} edições com IA por vídeo.',
    generateTitle: 'Gere mais imagens com o Pro',
    generateBody: 'O Pro inclui {n} imagens novas por vídeo.',
    voiceTitle: 'Refaça uma narração com o Pro',
    voiceBody: 'Mude o texto ou a voz de qualquer cena. O Pro inclui {n} trocas de voz por vídeo.',
    qualityTitle: "Imagens desenhadas com o nosso melhor modelo",
    qualityBody: "O Pro desenha cada imagem com o nosso melhor modelo e exporta sem marca d’água.",
    longerTitle: 'Faça vídeos mais longos com o Pro',
    longerBody: 'Um vídeo do pacote vai até 3 minutos. No Pro eles vão até 10 minutos.',
    sceneTitle: "As cenas são do Pro",
    sceneBody: "Uma cena animada com som e vozes próprios, feita a partir da sua ideia. Assine o Pro e crie uma agora.",
    sceneFree: "Fazer como um vídeo narrado",
    withoutCharacters: "Fazer o vídeo sem personagens",
    seriesTitle: "Séries são do Pro",
    seriesBody: "Um episódio novo na sua agenda, escrito com antecedência e esperando sua revisão. Assine o Pro e comece uma.",
    charactersTitle: "Personagens recorrentes são do Pro",
    charactersBody: "O mesmo rosto em cada cena e cada vídeo, desenhado uma vez a partir de uma descrição ou foto. Assine o Pro e crie seu elenco.",
    subscriberFeatureBody: 'Este vídeo já usou o que o seu plano dá a ele. Cada pacote que você adiciona dá mais a cada vídeo.',
    planNoWatermark: 'Sem marca d’água nos seus vídeos',
    planLonger: 'Vídeos de até 10 minutos',
    planAnimate: 'Imagens animadas e edições com IA',
    planSeason: 'Assine em outubro e ganhe {n} vídeos com IA extras',
  },
  // Os clipes de um projeto de Clipes com IA: os cartões e o remix de um deles
  common: {
    close: 'Fechar',
  },

  connection: {
    lost: 'Não conseguimos falar com o Clip-Short agora: esta página pode estar desatualizada. Seus vídeos continuam sendo processados.',
    retrying: 'Tentando de novo…',
  },

  clips: {
    nextSteps: { title: "Torne seu clipe impossível de passar batido", text: "O Remix monta um vídeo de comentário novo em volta do clipe: uma abertura que prende, o contexto pesquisado com uma fonte para cada fato, nomes na tela, gráficos e uma pergunta para fechar. Ou duble em outro idioma.", close: 'Fechar' },
    show: 'Mostrar',
    filters: { all: 'Todos', top: 'Os melhores', exported: 'Exportados' },
    sortLabel: 'Ordenar os clipes',
    sortBest: 'Melhores primeiro',
    sortTimeline: 'Ordem do vídeo',
    emptyExported: 'Você ainda não exportou nada. Os clipes exportados aparecem aqui, prontos para baixar.',
    empty: 'Ainda não há clipes aqui.',
    clipScore: 'Nota do clipe',
    clipScoreTitle: 'Nota do clipe {score} de 100',
    score: { excellent: 'Excelente', strong: 'Muito bom', good: 'Bom', fair: 'Razoável' },
    place: '{length} · {from}–{to} do vídeo original',
    why: 'Por que este clipe',
    captionsBurned: 'Legendas embutidas',
    captionsNone: 'Sem legendas',
    captionsNamed: "Legendas: {name}",
    playLabel: 'Reproduzir o clipe: {title}',
    openLabel: 'Abrir o clipe: {title}',
    editLabel: 'Editar o clipe: {title}',
    download: 'Baixar',
    open: 'Abrir o clipe',
    edit: 'Editar o clipe',
    export: 'Exportar o clipe',
    exporting: 'Exportando…',
    project: {
      clippingTitle: 'Procurando seus clipes',
      clippingDone: 'Você pode sair: os clipes aparecem aqui quando estiverem prontos.',
      captionsTitle: 'Transcrevendo seu vídeo',
      captionsDone: 'Você pode sair: a transcrição aparece aqui quando estiver pronta.',
      reframeTitle: 'Reenquadrando seu vídeo',
      reframeDone: 'Você pode sair: o vídeo reenquadrado aparece aqui quando estiver pronto.',
      stepFetch: 'Baixando o vídeo',
      stepMoments: 'Procurando os melhores momentos',
      stepFraming: 'Enquadrando e legendando cada clipe',
      stepListening: 'Ouvindo cada palavra',
      stepSaving: 'Salvando a transcrição',
      stepTracking: 'Seguindo o assunto e reenquadrando cada plano',
      stepUploading: 'Enviando o resultado',
      wentWrong: 'Algo deu errado. Tente de novo.',
      usually: 'Costuma levar alguns minutos.',
      lookingFor: 'Procurando:',
      didntFinish: 'Não terminou',
      noMomentsTitle: 'A IA não achou momentos claros suficientes neste vídeo.',
      noMomentsHint: 'Tente um pedido mais amplo, ou peça menos clipes.',
      noSoundTitle: 'Este vídeo não tem som.',
      noSoundHint: 'As legendas vêm do que é falado. Tente um vídeo em que alguém fala.',
      fetchTitle: 'Não conseguimos baixar este vídeo.',
      fetchHint: 'Ele pode ser privado, ter restrição de idade ou ter sido removido. Confira o link, ou envie o arquivo.',
      downloadSlowTitle: "O download não terminou a tempo.",
      downloadSlowHint: "Um vídeo muito longo (de várias horas, como a gravação de uma live) pode levar mais tempo do que permitimos, mesmo que você corte só uma parte. Envie o arquivo, ou um vídeo mais curto.",
      ytUnavailableTitle: "Este vídeo não está mais no YouTube.",
      ytPrivateTitle: "Este vídeo é privado no YouTube.",
      ytAgeTitle: "O YouTube deixa este vídeo atrás de uma verificação de idade.",
      ytMembersTitle: "Este vídeo é só para membros do canal.",
      ytRegionTitle: "O YouTube não mostra este vídeo de onde o baixamos.",
      ytNotYetTitle: "Este vídeo ainda não estreou no YouTube.",
      ytHint: "Tentar de novo não vai mudar isso. Escolha outro vídeo, ou envie o arquivo se você o tiver.",
      ytNotYetHint: "Tente de novo quando ele tiver estreado, ou envie o arquivo se você o tiver.",
      aiTitle: 'O serviço de IA não respondeu a tempo.',
      aiHint: 'Não há nada de errado com o seu vídeo: tente de novo daqui a pouco.',
      genericTitle: 'Algo deu errado ao processar este vídeo.',
      genericHint: 'Tente de novo. Se continuar falhando, os detalhes abaixo nos ajudam a investigar.',
      retryLabel: 'O que a IA deve procurar desta vez?',
      askedFor: 'Da última vez você pediu {n}',
      retrying: 'Tentando de novo…',
      retryChanged: 'Tentar com este pedido',
      retry: 'Tentar de novo',
      repromptTitle: 'Procurar clipes novos',
      repromptBody: 'A IA revê o vídeo inteiro com o seu pedido em mente. Os clipes novos entram junto dos que você já tem.',
      repromptPlaceholder: 'Ex.: A parte sobre preços, algo polêmico, a história do primeiro cliente…',
      have: 'Você já tem {n}',
      cancel: 'Cancelar',
      starting: 'Começando…',
      findClips: 'Procurar clipes',
      backAllClips: 'Voltar a todos os clipes',
      exportFailed: 'A exportação não começou',
      reframeFailed: 'Não foi possível começar o reenquadramento. Tente de novo.',
      deleteThis: 'Excluir este projeto',
      deleteConfirm: 'Excluir o projeto',
      deleteBody: 'Tem certeza de que quer excluir “{title}”? Isso apaga para sempre todos os dados deste projeto, inclusive os clipes já extraídos. Não dá para desfazer.',
      repromptPasses: 'Restam {left} de {limit} buscas neste vídeo. Esta gasta uma.',
      repromptPassesNone: 'Não restam buscas neste vídeo no seu plano.',
      repromptRefused: 'As buscas do seu plano neste vídeo acabaram ({used} de {limit}).',
      repromptFailed: 'Não foi possível começar a busca. Tente de novo.',
    },
    bar: {
      back: 'Voltar aos projetos',
      finding: 'Procurando clipes novos…',
      findingN: 'Procurando {n} clipes novos…',
      noClips: 'Ainda não há clipes',
      preparing: 'Preparando as prévias · {ready} de {total} prontas',
      ready: 'Prévias prontas',
      source: '{length} de origem',
      clips: '{n} clipes',
      clipsOne: '{n} clipe',
      more: 'Mais ações',
      deleteProject: 'Excluir o projeto',
      runsLabel: 'Clipes de',
      findNew: 'Procurar clipes novos…',
      findNewLocked: 'Procurar clipes novos',
      repromptLimit: 'As buscas do seu plano {plan} neste vídeo acabaram ({used} de {limit}). Planos maiores têm mais.',
      runOriginal: 'Original',
      runAll: 'Todos',
      runPrompt: 'Pedido {n}',
    },
    status: {
      exporting: 'Exportando…',
      waiting: 'Aguardando para exportar (2 por vez)',
      captioning: 'Adicionando legendas…',
      exportFailed: 'A exportação falhou',
      captionsFailed: 'As legendas falharam',
      exportedCaptions: 'Exportado com legendas',
      exported: 'Exportado',
      queued: 'Na fila para a prévia',
      preparing: 'Preparando a prévia…',
      ready: 'Pronto',
      outdated: 'Prévia desatualizada',
      previewFailed: 'A prévia falhou',
      noPreview: 'Ainda sem prévia',
    },
    remixes: {
      one: 'Remix deste clipe',
      many: '{n} remixes deste clipe',
      making: 'Criando…',
      ready: 'Pronto',
      failed: 'Falhou',
    },
    remix: {
      dubSound: "Dublagem em {language}",
      action: 'Remix',
      tooltip: 'Crie um vídeo novo em volta deste clipe: um título na tela, um gancho narrado, comentários enquanto ele toca e um fecho',
      title: 'Remix deste clipe',
      lead: "Um vídeo novo montado em volta do seu clipe, escrito a partir do que é dito nele.",
      untitled: 'Clipe sem título',
      ownSound: 'toca com o som dele',
      format: 'Formato',
      formats: {
        didYouKnow: {
          kicker: "Você sabia?",
          headline: "Quase todo mundo erra isso",
          label: 'Você sabia?',
          description: 'Um gancho surpreendente que o clipe responde.',
          example: '“Você sabia que quase todo mundo erra nisso?”',
        },
        explainer: {
          kicker: "Explicado",
          headline: "O que isso significa de verdade",
          label: 'Explicação',
          description: 'Primeiro o contexto, depois ele para para explicar.',
          example: '“É isto que você precisa saber antes de assistir.”',
        },
        hotTake: {
          kicker: "Opinião forte",
          headline: "Ninguém está falando isso",
          label: 'Opinião',
          description: 'Reage enquanto o clipe toca e depois dá a opinião dele.',
          example: '“É a resposta mais honesta que ouvi em muito tempo.”',
        },
        backstory: {
          kicker: "A história",
          headline: "Como tudo começou",
          label: 'A história por trás',
          description: 'A história que leva até este momento.',
          example: '“Tudo começou com uma pergunta…”',
        },
        custom: {
          kicker: "Sua ideia",
          headline: "Seu vídeo, do seu jeito",
          label: 'Do seu jeito',
          description: 'Descreva o vídeo que você quer.',
        },
      },
      direction: 'Instruções',
      describe: 'Descreva seu vídeo',
      directionPlaceholder: 'Opcional: algo em que focar, ou um tom. Ex.: “deixe divertido”, “foque na segunda metade”.',
      describePlaceholder: 'Ex.: Comece com a pergunta do início e depois explique por que isso importa para os estudantes.',
      commentary: 'Quanto a IA comenta',
      levels: {
        light: { summary: "Poucos comentários", label: 'Pouco', hint: 'Gancho e fecho, e no máximo um comentário dentro do clipe.' },
        balanced: { summary: "Comentários equilibrados", label: 'Equilibrado', hint: 'Um comentário a cada 25 segundos de clipe, até 3.' },
        lots: { summary: "Muitos comentários", label: 'Muito', hint: 'Reage bastante: um comentário a cada 15 segundos, até 6.' },
      },
      language: 'Idioma da narração',
      voice: 'Voz',
      playVoice: 'Ouvir uma amostra da voz',
      stopVoice: 'Parar a amostra da voz',
      optional: "(opcional)",
      narration: "Voz e idioma",
      costLeft: "Usa um vídeo de IA (restam {n}). Pronto em um ou dois minutos.",
      costUnlimited: "Pronto em um ou dois minutos.",
      costPro: "Feito com o Pro ou um pacote de vídeos, sem marca d’água.",
      // The sketch of the remix beside the choices (RemixPreview.jsx)
      preview: {
        label: "Seu remix",
        hook: "Gancho",
        clip: "Clipe",
        comment: "Comentário",
        ending: "Final",
        note: "Um esboço: a IA escreve o título e cada comentário a partir do que é dito no clipe.",
        voiceOver: "Uma voz de IA abre o vídeo",
      },
      // Remix v2: angles instead of formats (components/Remix/AnglePicker.jsx)
      v2: {
        lead: "A IA lê o seu clipe, encontra a história por trás e monta um vídeo novo em volta dele: uma abertura com o melhor momento, o contexto com cenas do vídeo, gráficos, os comentários dela e um final.",
        step: "Escolha um ângulo",
        reading: "Lendo o seu clipe para sugerir ângulos…",
        failed: "Desta vez não saíram ângulos. Deixe a IA escolher ou escreva o seu.",
        aiChoice: "Deixar a IA escolher",
        aiChoiceHint: "Ela escolhe a história mais forte do clipe e do que encontrar sobre ele.",
        own: "Meu próprio ângulo",
        ownPlaceholder: "Sobre o que o vídeo deve ser? Ex.: “A história por trás deste momento”",
      },
      // Editing a v2 remix on its video page (components/Remix/RemixV2Editor.jsx)
      v2edit: {
        title: "Editar o remix",
        kicker: "Etiqueta",
        line: "Linha {n} do título",
        stars: "Coloque entre *asteriscos* as palavras a destacar: elas aparecem na cor de destaque.",
        question: "Pergunta final",
        name: "Nome",
        role: "Função",
        removeTag: "Remover esta etiqueta de nome",
        graphic: "Cena {n}: {kind}",
        removeGraphic: "Remover este gráfico",
        shots: "Tomadas",
        shotsHint: "Cada parte narrada mostra tomadas do vídeo original. Escolha outra: ela é salva na hora.",
        part: "Parte {n}",
        change: "Trocar",
        useShot: "Usar esta tomada",
        cancel: "Cancelar",
        shotsLoading: "Carregando as tomadas…",
        shotsFailed: "Não foi possível carregar as tomadas.",
        noShots: "Este vídeo não tem outras tomadas perto do clipe.",
        shotFailed: "Não foi possível trocar a tomada. Tente de novo.",
        kinds: {
          display: "painel",
          target: "alvo",
          gauge: "medidor",
          counter: "contador",
          pin: "local",
          document: "documento",
          stamp: "carimbo",
        },
        fields: {
          label: "Rótulo",
          note: "Nota",
          stamp: "Carimbo",
          value: "Número",
          title: "Local",
          sub: "Linha de baixo",
          header: "Cabeçalho",
          line: "Linha",
          cutNote: "Nota ao riscar",
          keptText: "Carimbo ao manter",
          text: "Texto",
        },
        quote: "Citação, cena {n}",
        failed: "Não deu para salvar. Tente de novo.",
        saved: "Salvo",
        save: "Salvar alterações",
      },
      cancel: 'Cancelar',
      submit: "Fazer o remix",
      submitPro: "Remix com Pro",
      starting: 'Começando…',
      off: 'O Remix não está ativado neste servidor (REMIX_ENABLED).',
      failed: 'Não foi possível começar o remix. Tente de novo em instantes.',
    },
    // O espaço de trabalho do clipe: o editor em que ele abre — sua
    // transcrição, o palco, a linha do tempo, o enquadramento, os ajustes
    // e a faixa de clipes
    workspace: {
      backToPreview: 'Voltar para a prévia',
      // Os três painéis, e o que impede editar um clipe já exportado
      transcript: 'Transcrição',
      preview: 'Prévia',
      settings: 'Ajustes do clipe',
      selectClip: 'Escolha um clipe para ver a prévia dele.',
      lockedExported: 'Os clipes exportados mantêm suas legendas. Edite uma cópia para mudá-las.',
      lockedExporting: 'Bloqueado enquanto o clipe é exportado',
      prepareFailed: 'Não foi possível preparar a prévia',
      captionsSaveFailed: 'Não foi possível salvar as legendas',
      exportFailed: 'A exportação não começou',
      // A transcrição da esquerda
      transcriptText: 'Texto da transcrição',
      wordText: 'Texto da palavra',
      saving: 'Salvando…',
      editsSaved: 'Suas edições estão salvas · um ponto devolve uma palavra cortada',
      editHint: 'Clique em qualquer palavra para corrigi-la · apague-a para cortá-la',
      restoreOriginal: 'Restaurar o original',
      loadingTranscript: 'Carregando a transcrição…',
      transcribing: 'Transcrevendo. A transcrição chega junto com a prévia.',
      noTranscript: 'Ainda não há transcrição. Prepare a prévia para transcrever este clipe.',
      noSpeech: 'Neste clipe ninguém fala.',
      editWord: 'Editar “{word}”',
      playFrom: 'Reproduzir a partir de “{word}”',
      putBack: 'Devolver “{word}”',
      // A barra acima do palco
      aspectRatio: 'Proporção',
      framing: 'Enquadramento',
      automatic: 'Automático',
      editedShotOne: 'Editado ({n} plano)',
      editedShots: 'Editado ({n} planos)',
      adjustFraming: 'Ajustar o enquadramento',
      preparePreview: 'Preparar a prévia',
      refreshPreview: 'Atualizar a prévia',
      refreshing: 'Atualizando…',
      refresh: 'Atualizar',
      outdatedHint: 'Este clipe agora começa ou termina fora do trecho que foi preparado, então a prévia está atrasada. As exportações são renderizadas em qualidade total de qualquer forma.',
      previewQuality: 'Qualidade da prévia',
      qualityHint: 'O que a prévia reproduz. As exportações são sempre renderizadas a partir do original em resolução total.',
      // A etiqueta sobre a imagem: o que está sendo reproduzido
      badgeFast: 'Prévia em 360p',
      badgeToHd: 'Uma prévia rápida em 360p. As exportações são renderizadas em resolução total. Mude para HD',
      badgeToFast: 'Reproduzindo o original. Mude para a prévia rápida em 360p',
      badgeStatic: 'Uma prévia rápida em 360p. A exportação é renderizada em resolução total',
      // A linha do tempo abaixo do palco
      play: 'Reproduzir',
      pause: 'Pausar',
      mute: 'Silenciar',
      unmute: 'Ativar o som',
      playhead: 'Cursor de reprodução',
      trimInHandle: 'Cortar a entrada',
      trimOutHandle: 'Cortar a saída',
      framingPin: 'Marca de enquadramento',
      // O modo de enquadramento
      editedShot: 'plano editado',
      automaticShot: 'plano automático',
      split: 'Dividir',
      splitHint: 'Divide em dois cortes empilhados a partir daqui',
      merge: 'Juntar',
      mergeHint: 'Volta a um único corte a partir daqui',
      pin: 'Fixar',
      pinHint: 'Fixe o enquadramento aqui. Adicione outra marca para deslizar entre elas',
      deletePin: 'Excluir a marca',
      deletePinHint: 'Remove a marca que está no cursor. O enquadramento em volta continua',
      resetShot: 'Redefinir o plano',
      resetShotHint: 'Enquadramento automático para este plano',
      resetAll: 'Redefinir tudo',
      resetAllHint: 'Enquadramento automático em todos os planos',
      cancel: 'Cancelar',
      done: 'Pronto',
      saveDone: 'Salvar e pronto',
      framingHint: 'Arraste a caixa para reenquadrar este plano. Os outros planos mantêm o enquadramento automático.',
      // Os ajustes da direita
      trim: 'Cortar',
      long: '{length} de duração',
      trimIn: 'Entrada',
      trimOut: 'Saída',
      stepEarlier: '{label} 1 segundo antes',
      stepLater: '{label} 1 segundo depois',
      trimLocked: 'Os clipes exportados mantêm seus tempos.',
      trimHint: 'Corte à vontade ou estenda: o que passar da parte preparada ganha enquadramento e legendas sozinho, enquanto você continua editando.',
      captions: 'Legendas',
      burnCaptions: 'Embutir as legendas',
      captionsExported: 'As legendas fazem parte do arquivo exportado. Mude-as para renderizar uma versão nova.',
      changeCaptions: 'Mudar as legendas…',
      hintBurned: 'legendas embutidas',
      hintCaptions: 'legendas {name}',
      hintNoCaptions: 'sem legendas',
      openEditor: 'Abrir no editor completo',
      // A faixa de clipes de baixo
      clipsTitle: 'Clipes',
      drag: 'arraste',
      scoreTitle: 'Nota do clipe {score} de 100',
      zoomIn: 'Aproximar',
      zoomOut: 'Afastar',
      editHintTouch: 'Toque em qualquer palavra para corrigi-la · apague-a para cortá-la',
      tools: 'Ferramentas',
      sheetMore: 'Mostrar mais do painel',
      sheetLess: 'Mostrar menos do painel',
    },
    feed: { label: 'Clipes, um por tela', soundOn: 'Ligar o som', soundOff: 'Desligar o som' },
  },

  // As páginas de cada ferramenta: o hero, o compositor, a configuração
  // quando já há um vídeo, e os projetos abaixo
  toolPage: {
    step1: 'Cole um link ou solte um arquivo',
    clipping: {
      headline: 'Cole um vídeo. Publique as melhores partes.',
      sub: 'A IA acha os momentos que prendem a atenção, enquadra quem fala na vertical e grava as legendas. Você revisa, ajusta e exporta.',
      step: 'Dê uns 3 minutos',
      last: 'Revise, ajuste e exporte',
      eta: '3 minutos',
      setup: 'Configure seus clipes',
      note: 'Uns {eta} · A IA escolhe a duração de cada clipe; depois é só cortar.',
      cta: 'Gerar clipes',
    },
    captions: {
      headline: 'Legendas que as pessoas leem de verdade.',
      sub: 'A IA transcreve cada palavra e grava as legendas no estilo que você escolher. Cole um link ou solte um arquivo.',
      step: 'Dê uns 2 minutos',
      last: 'Veja e baixe',
      eta: '2 minutos',
      setup: 'Pronto para legendar',
      setupSub: 'A IA transcreve cada palavra no ritmo da voz. O estilo das legendas você escolhe no resultado.',
      note: 'Uns {eta}',
      cta: 'Gerar legendas',
    },
    reframe: {
      headline: 'Qualquer vídeo, qualquer formato.',
      sub: 'A IA reenquadra qualquer vídeo em volta do assunto: vertical, quadrado ou largo. Cole um link ou solte um arquivo.',
      step: 'Dê uns 2 minutos',
      last: 'Veja e baixe',
      eta: '2 minutos',
      setup: 'Configure o reenquadramento',
      note: 'Uns {eta} · A IA mantém o assunto no quadro, plano a plano.',
      cta: 'Reenquadrar vídeo',
    },
    segment: {
      title: 'O que processar',
      whole: 'Vídeo inteiro · {length}',
      choose: 'Escolher uma parte',
      first: 'Os primeiros {time}',
      from: 'De',
      to: 'Até',
      startLabel: 'Início da parte',
      endLabel: 'Fim da parte',
      frameAt: 'Quadro em {time}',
      watch: 'Assistir a partir de {time} no YouTube',
      wholeVideo: 'O vídeo inteiro',
      toProcess: '{length} para processar',
      uses: 'usa {used} dos {left} minutos que restam',
      minClipping: 'Clipes com IA precisa de pelo menos 5 minutos para achar clipes.',
      minCaptions: 'Escolha pelo menos alguns segundos.',
      maxReframe: 'O reenquadramento processa até 30 minutos por vez.',
      overMinutes: 'São {length} minutos e o seu plano tem {left} neste mês.',
      choosePart: ' Escolha uma parte para processar só um pedaço.',
      noteReframe: 'O reenquadramento processa até 30 minutos por vez, então escolhemos os primeiros {time}. Arraste os controles para escolher outra parte.',
      noteMinutes: 'Seu plano tem {n} minutos neste mês, então escolhemos os primeiros {time}. Arraste os controles para escolher outra parte, ou processe o vídeo inteiro em um plano maior.',
    },
    clipSetup: {
      tooShort: 'Este vídeo tem menos de 5 minutos: é curto demais para tirar clipes. Escolha um mais longo.',
      tooShortTry: 'Mas este vídeo serve para:',
      tooShortReframe: 'Deixar vertical (9:16)',
      tooShortCaptions: 'Adicionar legendas',
      howMany: 'Quantos clipes',
      suggest: 'Sugerimos {n} para {length} de vídeo',
      suggested: ' (sugerido)',
      minutes: '{n} min',
      hours: '{h} h {m} min',
      promptLabel: 'O que a IA deve procurar?',
      optional: 'opcional',
      promptPlaceholder: 'Ex.: A parte dos preços, pule a introdução, nada antes do minuto 5',
      ideasLabel: 'Ideias para o pedido',
      ideas: {
        funniest: 'Os momentos mais engraçados',
        takeaways: 'As ideias principais',
        opinions: 'Opiniões fortes',
      },
      suggestPart: 'Sugerimos {n} para a parte de {length}',
    },
    composer: {
      upload: 'Enviar',
      placeholder: 'Cole um link do YouTube, Twitch, Drive ou X…',
      urlLabel: 'URL do vídeo',
      clearUrl: 'Limpar a URL',
      paste: 'Colar',
      drop: 'Solte seu vídeo para enviar',
      dropHint: 'ou arraste e solte um arquivo de vídeo aqui',
      showcaseTimed: 'Cada palavra, no ritmo da voz',
      showcaseStyle: 'No estilo que você escolher',
      captionStyle: 'Estilo das legendas',
      worksWith: 'Funciona com',
      clearFile: 'Remover o arquivo escolhido',
      reading: 'Lendo o vídeo…',
      readingSlow: 'Este está demorando alguns segundos. Ainda está indo.',
      yourVideo: 'Seu vídeo',
      ready: 'Pronto',
      views: '{n} visualizações',
    },
    ready: {
      notUploaded: 'Escolhido · ainda não enviado',
      notThisOne: 'Não é este?',
      anotherFile: 'Escolher outro arquivo',
      anotherLink: 'Colar outro link',
      uploading: 'Enviando',
      uploadFile: 'Enviar o arquivo',
    },
    button: {
      starting: 'Começando…',
      uploading: 'Enviando…',
      chooseFile: 'Escolha um arquivo',
      uploadFirst: 'Envie o arquivo primeiro',
      invalidLink: 'Cole um link válido',
    },
    reframeSetup: {
      format: 'Formato de saída',
      padding: 'Quando um plano não preenche o quadro',
      paddingNote: 'preenchimento',
      blur: 'Desfoque',
      black: 'Preto',
      tooLong: 'Este vídeo tem {minutes} minutos. O reenquadramento processa até 30 minutos por vez.',
      over30: 'mais de 30',
    },
    existing: {
      clips: 'Você já tem clipes deste vídeo{detail}.',
      captions: 'Você já tem legendas deste vídeo{detail}.',
      reframe: 'Você já tem um reenquadramento deste vídeo{detail}.',
      open: 'Abrir →',
      clipCount: '{n} clipes',
    },
    refusal: {
      firstMinutes: 'Faça clipes com os primeiros {n} minutos',
      moreMinutes: 'Conseguir mais minutos',
    },
    projects: {
      title: 'Seus projetos',
      inProgress: 'Em andamento',
      loadError: 'Erro ao carregar os projetos',
      emptyTitle: 'Ainda não há projetos',
      emptyBody: 'Cole um link acima: seus primeiros clipes estão a poucos minutos.',
      emptyCaptionsTitle: 'Ainda não há legendas',
      emptyCaptionsBody: 'Cole um link acima: seu vídeo legendado está a poucos minutos.',
      emptyReframeTitle: 'Ainda não há reenquadramentos',
      emptyReframeBody: 'Cole um link acima: o reenquadramento leva mais ou menos o tempo do próprio vídeo.',
      emptyCta: 'Adicionar um vídeo',
      emptyDefault: 'Cole um link acima: seu primeiro resultado está a poucos minutos.',
    },
    limit: {
      title: 'Você atingiu o limite do mês',
      body: 'Você já usou todos os projetos deste mês. Assine o Pro para ter projetos ilimitados.',
      close: 'Fechar',
      pricing: 'Ver preços',
    },
    remove: {
      title: 'Excluir o projeto?',
      body: 'Tem certeza de que quer excluir “{title}”? Isso não dá para desfazer.',
      thisProject: 'este projeto',
      stillCounts: "Excluir não devolve o vídeo: ele continua contando.",
      cancel: 'Cancelar',
      deleting: 'Excluindo…',
      confirm: 'Excluir',
    },
    card: {
      processing: 'Processando…',
      failed: 'Falhou',
      deleteLabel: 'Excluir o projeto',
      clips: '{n} clipes',
      scenes: '{n} cenas',
      scene: "Cena",
      series: 'Série · {name}',
    },
  },

  // A scene clip: one short animated scene with its own sound (components/AIAgent/Scene*.jsx)
  studio: {
    label: "Estúdio de IA",
    seeAll: "Ver todos",
    open: "Mostrar o que há em {name}",
    close: "Ocultar o que há em {name}",
    videoTitle: "Crie um vídeo",
    videoSubtitle: "Um narrador conta a sua ideia sobre imagens e legendas. De 1 a 10 minutos.",
    modes: {
      video: {
        name: "Vídeo",
        what: "Com narrador, de 1 a 10 minutos",
        new: "Novo vídeo",
      },
      scenes: {
        name: "Cenas",
        what: "Uma tomada animada de {n} segundos",
        new: "Nova cena",
      },
      series: {
        name: "Séries",
        what: "Vídeos novos em um horário",
        new: "Nova série",
      },
      characters: {
        name: "Personagens",
        what: "Seu elenco de sempre",
        new: "Novo personagem",
      },
    },
    empty: {
      video: "Seus vídeos vão aparecer aqui.",
      scenes: "Suas cenas vão aparecer aqui.",
      series: "Suas séries vão aparecer aqui.",
      characters: "Seus personagens vão aparecer aqui.",
    },
  },
  sceneGuide: {
    sceneTitle: "Sua ideia é um momento só. Experimente uma Cena",
    sceneBody: "Os vídeos são contados por um narrador sobre imagens. Um momento animado é feito em Cenas.",
    storyTitle: "Sua ideia é uma história inteira",
    storyBody: "O vídeo com narrador conta tudo. Uma Cena mostraria só um momento dela.",
    videoName: "Vídeo com narrador",
    videoFacts: [
      "Um narrador conta sobre imagens e legendas",
      "De 1 a 10 minutos",
      "Ideal para um assunto ou uma história inteira",
    ],
    sceneName: "Cena",
    sceneFacts: [
      "Uma cena animada de {n} segundos",
      "Os personagens se mexem e falam com a própria voz",
      "Ideal para um único momento",
    ],
    recommended: "Recomendado",
    goToScenes: "Ir para Cenas com a minha ideia",
    oneMoment: "Fazer só um momento dela em Cenas",
    makeVideo: "Fazer o vídeo com narrador",
    changeIdea: "Mudar minha ideia",
    cost: "Qualquer um dos dois usa um dos seus vídeos.",
  },
  sceneStudio: {
    seoTitle: "Cenas: uma tomada animada com vozes",
    title: "Crie uma cena",
    subtitle: "Uma tomada animada de {n} segundos, com vozes e som próprios. Pronta em mais ou menos um minuto.",
    guide: "Diga quem aparece, o que faz e o que fala. Um momento, não uma história inteira.",
    lookLabel: "Estilo",
    looks: { asDescribed: "Como você descrever", animated3d: "Animação 3D", realistic: "Realista", anime: "Anime", clay: "Massinha", cartoon: "Desenho animado" },
    shapeLabel: "Formato",
    vertical: "Vertical 9:16",
    horizontal: "Horizontal 16:9",
    languageLabel: "As vozes falam",
    languageHint: "Só para as falas que você não escrever.",
    cost: "Usa 1 dos seus vídeos · {n} s · mais ou menos um minuto",
    costLeft: "Usa 1 dos seus {left} vídeos · {n} s · mais ou menos um minuto",
    creating: "Preparando sua cena…",
    needIdea: "Primeiro descreva o momento: uma frase basta.",
    exampleTitle: "Isto é uma cena",
    exampleHint: "Feita com esta ideia:",
    another: "Ver outra",
    useIdea: "Usar esta ideia",
    exampleIdeas: {
      cat: "Um gato laranja pula na mesa da cozinha e derruba uma xícara de café. Olha para a câmera e diz: Não fui eu.",
      astronaut: "Um astronauta abre a escotilha da nave e encontra uma praia tropical. Tira o capacete e diz: Isso não é Marte.",
      dino: "Um pequeno dinossauro de massinha tenta soprar as velas do bolo de aniversário e não alcança com os bracinhos. Ele diz: De novo não!",
    },
    mine: "Suas cenas",
    mineEmpty: "Suas cenas ficam aqui. Cada uma pode ser salva ou compartilhada.",
    making: "Animando…",
    failed: "Não foi feita",
    toVideoLead: "Quer contar uma história inteira, com narrador?",
    toVideo: "Criar um vídeo",
    back: "Voltar às cenas",
  },
  sceneClip: {
    examples: [
      "Um gato laranja pula na mesa da cozinha e derruba uma xícara de café. Olha para a câmera e diz: Não fui eu.",
      "Um astronauta abre a escotilha da nave e encontra uma praia tropical. Tira o capacete e diz: Isso não é Marte.",
      "Um pequeno dinossauro de massinha tenta soprar as velas do bolo de aniversário e não alcança com os bracinhos. Ele diz: De novo não!",
    ],
    offer: {
      sceneTitle: "Isso parece uma cena",
      sceneBody: "Um vídeo narrado falaria sobre isso. Uma cena mostra: uma tomada de {n} segundos, com som e vozes próprios.",
      storyTitle: "Isso é uma história inteira",
      storyBody: "Um vídeo narrado conta tudo. Ou veja como ela começa: uma tomada de {n} segundos, animada, com som e vozes próprios.",
      makeScene: "Criar a cena de {n} segundos",
      firstScene: "Animar a primeira cena",
      makeVideo: "Criar o vídeo narrado",
      cost: "Qualquer um dos dois usa um dos seus vídeos.",
      blocked: {
        real_person: "Não podemos mostrar uma pessoa real com nome",
        religious_figure: "Não podemos mostrar uma figura religiosa",
        own_picture: "Não podemos usar a sua foto nem o rosto de uma pessoa específica",
        known_character: "Não podemos usar personagens de um filme, uma série, um jogo ou uma marca",
        adult: "Não podemos mostrar nudez nem conteúdo sexual",
      },
      blockedBody: "Podemos fazer um vídeo narrado sobre o assunto. Ou descreva um personagem criado por você, e nós animamos.",
      change: "Mudar minha ideia",
      noCast: "Uma cena ainda não usa os seus personagens salvos.",
    },
    errors: {
      refused: "Não conseguimos fazer esta cena do jeito que você descreveu, e o seu vídeo não foi usado. Tente descrever de outro jeito.",
      create: "Não foi possível começar a cena, e o seu vídeo não foi usado. Tente de novo daqui a pouco.",
    },
    page: {
      badge: "Cena",
      making: "Animando a sua cena",
      finishing: "Finalizando a sua cena",
      wait: "Leva cerca de um minuto. Fique aqui: ela toca assim que ficar pronta.",
      ready: "A sua cena está pronta",
      save: "Salvar o vídeo no seu aparelho",
      send: "Enviar para um app",
      sound: "Toque para ouvir",
      another: "Criar outra cena",
      removeWatermark: "Tirar a marca d'água",
      idea: "Sua ideia",
      failedTitle: "Esta cena não foi feita",
      failed: {
        refused: "Não conseguimos fazer esta cena do jeito que você descreveu. Tente descrever de outro jeito.",
        timeout: "Demorou demais e nós paramos.",
        error: "Algo deu errado enquanto ela era feita.",
        start: "Algo deu errado antes de começar.",
      },
      givenBack: "O seu vídeo voltou para a sua conta: você pode usar de novo.",
      tryAgain: "Tentar outra ideia",
      narrated: "Fazer como vídeo narrado",
    },
  },
  aiAgentPage: {
    // The owner's own pictures under the idea box (components/AIAgent/IdeaImages.jsx)
    images: { add: 'Adicionar imagens', addMore: 'Adicionar mais {{left}}', hint: 'Até 3: seu produto, logo, lugar, pet... A IA usa no seu vídeo.', remove: 'Remover imagem', uploading: 'Enviando', failed: 'Não foi possível enviar esta imagem', alt: 'Sua imagem {{n}}' },
    seriesNudge: {
      title: 'Você já fez {n} vídeos. Que tal os próximos virarem uma série?',
      text: "Vídeos novos sobre a mesma ideia, no horário que você escolher, e cada um espera você assistir. Começamos pela sua última ideia.",
      start: 'Virar série',
      close: 'Agora não',
    },
    mode: {
      label: 'O que fazer',
      video: 'Um vídeo',
      series: 'Uma série',
      seriesHint: "Vídeos novos sobre essa ideia, no horário que você escolher. Cada um espera você assistir antes de postar.",
      plan: 'Planejar minha série',
      startFrom: 'Ou comece com:',
      scene: "Uma cena",
      sceneHint: "Uma tomada de {n} segundos com som e vozes próprios, pronta em cerca de um minuto. Usa um dos seus vídeos.",
      makeScene: "Criar a cena",
      scenePlaceholder: "Descreva um momento: quem aparece, o que faz e o que diz…",
    },
    seoTitle: 'Gerador de vídeos com IA: crie vídeos a partir de texto',
    seoDescription: 'Gere vídeos profissionais a partir de uma ideia com IA: roteiro, imagens, narração e legendas para TikTok, Reels e YouTube Shorts em minutos.',
    title: 'Estúdio do Agente de Vídeo com IA',
    subtitle: 'Transforme suas ideias em vídeos envolventes, com narração realista e visual de cinema.',
    howItWorks: 'Veja como funciona',
    how: {
      title: "Como um vídeo é feito",
      subtitle: "De uma frase a um vídeo narrado, em cerca de dois minutos.",
      idea: "Crie um vídeo sobre a história do café",
      generate: "Gerar",
      scene: "Cena {n}",
      lines: ["Nas tranquilas terras altas da antiga Etiópia, uma simples fruta começou uma história que mudou o mundo.", "Um pastor de cabras chamado Kaldi viu seu rebanho dançar depois de comer frutinhas vermelhas.", "Monges prepararam as frutas para ficar acordados nas orações da noite."],
      pictures: "Uma imagem para cada momento do roteiro",
      voice: "Narrador",
      ready: "Pronto para exportar",
      steps: {
        idea: { title: "Sua ideia", body: "Uma frase basta. Escolha idioma, estilo e duração se quiser." },
        script: { title: "O roteiro", body: "A IA escreve a história cena por cena, com um gancho na abertura." },
        make: { title: "Imagens e voz", body: "Cada cena ganha suas imagens, e um narrador lê o roteiro." },
        video: { title: "Seu vídeo", body: "Legendas, música e movimento são adicionados. Edite qualquer cena e exporte." },
      },
      try: "Testar com esta ideia",
      tour: "Mostrar na página",
    },
    exampleIdeas: [
      'Crie um documentário sobre a Independência do Brasil com mapa...',
      'Crie um vídeo sobre o mistério do Triângulo das Bermudas...',
      'Crie um vídeo que explique os juros compostos com gráficos...',
    ],
    prefilled: 'Sua ideia já está pronta. Ajuste o que quiser e gere o vídeo.',
    mismatch: 'Sua ideia está escrita em {idea}, mas a narração está em {narration}.',
    mismatchUse: 'Narrar em {idea}',
    mismatchKeep: 'Manter {narration}',
    stockFootage: 'Incluir imagens de banco',
    stockFootageHint: 'Combina imagens geradas por IA com fotos e vídeos reais do Pexels.',
    choices: {
      more: 'Mais',
      less: 'Menos',
      cast: 'Elenco de {n}',
    },
    generate: 'Gerar vídeo',
    generating: 'Gerando...',
    premium: 'Recurso premium',
    minutesShort: '{n} min',
    secondsShort: '{n} s',
    tryExample: 'Experimente um exemplo:',
    visualStyle: 'Estilo visual',
    narrator: 'Narrador',
    preview: 'Ouvir {name}',
    stop: 'Parar {name}',
    inspired: 'Inspire-se com vídeos criados pelo Agente de IA',
    tryThis: 'Usar esta ideia',
    tryShort: 'Usar',
    myProjects: 'Meus projetos',
    myProjectsHint: 'Gerencie e edite os vídeos que você gerou.',
    emptyTitle: 'Você ainda não tem vídeos com IA',
    emptyDescription: 'Escreva uma ideia acima e crie seu primeiro vídeo com IA.',
    emptyCta: 'Escreva sua ideia',
    ideaNeeded: 'Primeiro escreva sua ideia: uma frase sobre o assunto do vídeo. O texto cinza é só um exemplo.',
    ideaTooShort: 'Conte um pouco mais: pelo menos uma frase curta.',
    ideaPick: "Ou comece com uma destas:",
    videoLink: 'Isso é o link de um vídeo. Para tirar shorts dele, use Cortes com IA: ele encontra os melhores momentos e enquadra para você. O Agente de IA cria um vídeo novo a partir de uma ideia que você descreve.',
    videoLinkClips: 'Fazer cortes deste vídeo',
    videoLinkAnyway: 'Criar um vídeo sobre ele mesmo assim',
    useExample: 'Usar este exemplo',
    limitTitle: 'Você já usou todos os seus vídeos com IA por enquanto',
    limitBody: 'Você usou {used} de {limit}. Terá mais em {date}, ou faça upgrade para criar mais hoje.',
    limitBodyNoDate: 'Você usou {used} de {limit}. Faça upgrade para criar mais hoje.',
    limitTitleFree: "Você não tem mais vídeos com IA",
    limitBodyFree: "Assine o Pro, ou compre 3 vídeos Pro com pagamento único, e crie um hoje.",
    inProgress: { title: 'Seu vídeo ainda está sendo feito', open: 'Abrir' },
    limitIdeaKept: "Sua ideia fica guardada na caixa até lá.",
    limitShare: "Ou compartilhe um dos seus vídeos: quando um amigo que você trouxer pagar, você ganha um vídeo Pro.",
    limitOpenVideo: 'Seu vídeo está pronto. Abra para assistir e exportar.',
    limitCta: 'Ver planos',
    limitWaitTitle: 'Seu vídeo está sendo criado',
    limitWaitBody: 'Ele conta como um dos seus vídeos. Você o terá nos seus vídeos quando terminar.',
    limitWaitCta: 'Acompanhe seu vídeo',
    limitError: 'Você atingiu o limite de vídeos do Agente de IA. Faça upgrade do seu plano para criar mais.',
    createError: 'Não foi possível criar o projeto. Tente novamente.',
    longer: {
      title: 'Desbloqueie vídeos mais longos',
      body: 'Um vídeo do pacote vai até 3 minutos. Com o Pro, você gera vídeos de até 10 minutos.',
      cancel: 'Cancelar',
      pricing: 'Ver preços',
    },
    badges: { ai: 'Gerado por IA', stock: 'Banco de imagens + IA' },
    scenarios: {
      cleopatra: { title: 'A rainha Cleópatra', prompt: 'Crie um vídeo sobre a rainha Cleópatra...', subtitle: 'História • Documentário' },
      kyoto: { title: 'Kyoto antiga', prompt: 'Crie um guia cinematográfico de Kyoto...', subtitle: 'Viagem • Cinematográfico' },
      coffee: { title: 'História do café', prompt: 'Crie um vídeo sobre a história do café...', subtitle: 'Educação • Documentário' },
      texas: { title: 'Fazendeiro do Texas, 1850', prompt: 'vlog imaginário de um fazendeiro americano de 1850...', subtitle: 'História • Vlog' },
      joan: { title: "Joana d'Arc", prompt: "a história de Joana d'Arc...", subtitle: 'História • Documentário' },
      dreams: { title: 'Os sonhos', prompt: 'Crie um vídeo sobre os sonhos...', subtitle: 'Psicologia • Documentário' },
      history: { title: 'História desconhecida', prompt: 'Crie um vídeo sobre histórias pouco conhecidas...', subtitle: 'História • Documentário' },
    },
    tour: {
      back: 'Voltar',
      close: 'Fechar',
      last: 'Concluir',
      next: 'Próximo',
      skip: 'Pular tour',
      ideaTitle: 'Sobre o que é o vídeo?',
      ideaBody: 'Uma frase basta; o agente escreve o roteiro a partir dela.',
      generateTitle: 'Um único botão',
      generateBody: 'Seu vídeo leva alguns minutos; avisamos por e-mail quando estiver pronto.',
      projectsTitle: 'Seus vídeos',
      projectsBody: 'Cada vídeo que você faz fica guardado aqui.',
    },
  },
  // Signed-in app pages moved into the dictionary: account, results, subscription pages
  appShared: {
    projectNotFound: 'Projeto não encontrado',
    projectNotFoundBody: 'O projeto que você procura não existe ou você não tem acesso a ele.',
    backToProjects: 'Voltar aos projetos',
    errorTitle: 'Erro',
    errorBody: 'Algo deu errado. Tente de novo ou fale com o suporte se o problema continuar.',
    previous: 'Anterior',
    next: 'Próxima',
    statuses: {
      processing: 'Processando',
      completed: 'Pronto',
      failed: 'Falhou',
      pending: 'Na fila',
      deleted: 'Excluído',
    },
  },
  account: {
    title: 'Configurações da conta',
    seoTitle: 'Configurações da conta: seu perfil e sua assinatura',
    seoDescription: 'Gerencie sua conta do Clip-Short, veja seu plano, acompanhe seu uso e atualize seus dados de cobrança.',
    nav: {
      profile: 'Perfil',
      subscription: 'Assinatura',
      usage: 'Uso',
      notifications: 'Notificações',
    },
    profile: {
      heading: 'Suas informações',
      name: 'Nome',
      email: 'E-mail',
      notProvided: 'Não informado',
    },
    notifications: {
      heading: 'Notificações por e-mail',
      intro: 'Escolha quais e-mails você quer receber.',
      loadError: 'Não conseguimos carregar suas configurações de e-mail.',
      tryAgain: 'Tentar de novo',
      saveError: 'Não conseguimos salvar. Tente de novo.',
      transactionalLabel: 'Avisos dos seus projetos',
      transactionalDescription: 'Um e-mail quando um projeto que você começou fica pronto.',
      marketingLabel: 'Novidades e ofertas',
      marketingDescription: 'De vez em quando, novidades e ofertas do Clip-Short.',
    },
    usage: {
      heading: 'Uso',
      loadError: 'Não conseguimos carregar seu uso.',
      currentPeriod: 'Período de cobrança atual',
      processingMinutes: 'Minutos de processamento de vídeo',
      bundleLevel: 'Nível de pacote {quantity}: {quantity} × {per} min = {limit} min no total',
      carried: 'Inclui {n} que vieram do mês anterior',
      aiAgentProjects: 'Projetos do Agente de IA',
      needMore: 'Precisa de mais? Assine o Pro para ter limites maiores.',
      viewPricing: 'Ver preços',
      unavailable: 'Dados de uso indisponíveis.',
    },
    subscription: {
      heading: 'Detalhes da assinatura',
      refresh: 'Atualizar',
      refreshedTitle: 'Assinatura atualizada',
      refreshedBody: 'Os dados da sua assinatura foram atualizados.',
      errorTitle: 'Erro',
      refreshError: 'Não conseguimos atualizar os dados da sua assinatura.',
      portalErrorTitle: 'Erro no portal',
      portalErrorBody: 'Não conseguimos abrir o portal de gerenciamento da assinatura. Tente de novo.',
      billingMonthly: 'Cobrança mensal',
      billingAnnual: 'Cobrança anual',
      billingOther: 'Cobrança: {period}',
      billingUnavailable: 'Período de cobrança indisponível',
      statuses: {
        active: 'Ativa',
        trialing: 'Teste grátis',
        canceled: 'Cancelada',
        past_due: 'Pagamento atrasado',
        incomplete: 'Incompleta',
        unpaid: 'Não paga',
      },
      trialTitle: 'Teste grátis ativo',
      trialEndsBefore: 'Seu teste grátis de 7 dias termina em',
      trialEndsAfter: '.',
      trialNoCharge: 'Você não será cobrado até lá. Cancele quando quiser antes do fim do teste e não paga nada.',
      legacyTitle: 'Plano antigo',
      legacyBody: 'Você está em um plano antigo que não está mais disponível para novos clientes.',
      legacyKeep: 'Você pode manter seu preço e seus limites atuais, ou mudar quando quiser para o nosso novo plano Pro flexível.',
      legacyBadge: 'Antigo',
      trialLength: 'Teste grátis de 7 dias',
      bundles: '{count} pacotes',
      bundleIncludes: '({hours} h de processamento + {videos} vídeos com IA)',
      trialBadge: 'Teste',
      cancelPendingTitle: 'Cancelamento pendente',
      cancelPendingBody: 'Sua assinatura termina em {date}. Depois dessa data você perde o acesso aos recursos Pro.',
      limitProcessing: 'Processamento',
      limitAiVideos: 'Vídeos com IA',
      limitReprompts: 'Buscas novas',
      trialEnds: 'O teste termina em',
      periodEnds: 'O período atual termina em',
      status: 'Status',
      noRenew: 'A assinatura não será renovada automaticamente.',
      cancelsAtEnd: 'Cancela no fim do período',
      freeTrial: 'Teste grátis',
      openingPortal: 'Abrindo o portal...',
      manage: 'Gerenciar assinatura',
      noneTitle: 'Nenhuma assinatura ativa',
      noneBody: 'Assine um plano Pro para usar os recursos premium e ter limites de uso maiores.',
      viewPlans: 'Ver planos',
    },
  },
  captionsResult: {
    back: 'Voltar aos projetos de legendas',
    exportJson: 'Exportar JSON',
    exportJsonHint: 'Baixar a transcrição em JSON',
    starting: 'Começando a gerar o vídeo...',
    startFailed: 'Não conseguimos começar a gerar o vídeo',
    timedOut: 'A geração do vídeo demorou demais',
    complete: 'Vídeo pronto!',
    failed: 'Não foi possível gerar o vídeo',
    rendering: 'Gerando o vídeo com legendas...',
    checkFailed: 'Não conseguimos verificar o andamento do vídeo',
    wordsHeard: '{n} palavras detectadas',
    livePreview: 'Prévia ao vivo',
    rendered: 'Vídeo final',
    custom: 'Personalizado',
    transcriptPane: 'Transcrição',
    previewPane: 'Prévia',
    settingsPane: 'Configurações das legendas',
    noVideo: 'O vídeo não está disponível para a prévia.',
    renderingShort: 'Gerando…',
    renderAgain: 'Gerar de novo',
    burnIn: 'Gravar as legendas',
    videoButton: "Baixar vídeo",
    transcriptButton: 'Transcrição',
    openEditor: 'Abrir no editor completo',
  },
  captionControls: {
    fontSize: 'Fonte e tamanho',
    fontPlaceholder: 'Fonte...',
    size: 'Tamanho',
    sizeAria: 'Tamanho da fonte',
    wordGrouping: 'Agrupar palavras',
    casePlaceholder: 'Maiúsculas...',
    outline: 'Contorno',
    outlineAria: 'Contorno do texto',
    shadow: 'Sombra',
    shadowAria: 'Intensidade da sombra',
    textAppearance: 'Aparência do texto',
    glitch: 'Efeito glitch',
    glitchIntensity: 'Intensidade do glitch ({n}%)',
    glitchHint: 'Ajuste a intensidade do efeito glitch',
    glitchAria: 'Intensidade do glitch',
    glitchStroke: 'Cor do contorno (para o glitch)',
    captionBackground: 'Fundo das legendas',
    speakerColors: 'Uma cor para cada pessoa',
    backgroundColor: 'Cor de fundo',
    opacity: 'Opacidade ({n}%)',
    opacityAria: 'Opacidade do fundo',
    animationPlaceholder: 'Escolha uma animação...',
    animation: 'Animação',
    verticalPosition: 'Posição vertical',
    textColor: 'Cor do texto',
    highlightColor: 'Cor de destaque',
    cases: {
      uppercase: 'MAIÚSCULAS',
      lowercase: 'minúsculas',
      capitalize: 'Primeira Maiúscula',
      normal: 'Normal',
    },
    animations: {
      tiktok: 'Estilo TikTok',
      fade: 'Surgir',
      slide: 'Deslizar para cima',
      pop: 'Pop',
      glitch: 'Glitch',
    },
  },
  reframeResult: {
    analysing: 'Calculando o enquadramento para {aspect}…',
    analysisFailed: 'A análise do enquadramento falhou.',
    liveFramed: 'Isto é ao vivo, com o seu enquadramento. Ao gerar o vídeo, o arquivo sai exatamente assim.',
    live: 'Isto é ao vivo. Você só precisa gerar o vídeo para baixar um arquivo.',
    waiting: 'Escolha um formato para ver, ou gere um para baixar.',
    previewPane: 'Prévia',
    sourcePane: 'Original',
    resultPane: 'Reenquadrado',
    settingsPane: 'Configurações do reenquadramento',
    madeBlack: 'barras pretas onde um plano não alcança',
    madeBlur: 'preenchimento desfocado onde um plano não alcança',
    noSource: 'O vídeo original não está disponível.',
    sourceCaption: 'O vídeo que você enviou',
    liveCaption: '{aspect} · prévia ao vivo',
    resultCaption: 'Reenquadrado para {aspect}',
    shape: 'Formato',
    adjustFraming: 'Ajustar o enquadramento',
    paddingLabel: 'Quando um plano não preenche o quadro',
    paddingUnused: 'Não é usado: você definiu o enquadramento, então o arquivo sai exatamente como na prévia.',
    paddingHint: 'O desfoque preenche as bordas com o próprio plano; o preto deixa barras.',
    reframeTo: 'Reenquadrar para {aspect}',
    renderFramed: 'Gerar com o seu enquadramento',
    reframeAgain: 'Reenquadrar de novo',
    upToDate: "Este é o arquivo que você já tem. Mude o formato ou o enquadramento para fazer outro.",
    download: 'Baixar',
  },
  subscriptionResult: {
    backToVideo: 'Voltar ao seu vídeo',
    backToWork: 'Voltar para onde você estava',
    watermarkNext: 'Exporte seu vídeo de novo: ele sai sem marca d’água.',
    successSeoTitle: 'Assinatura ativada',
    successSeoDescription: 'Sua assinatura do Clip-Short está ativa. Comece hoje a criar vídeos curtos profissionais.',
    noSession: 'Não encontramos o ID da sessão no link',
    notFound: 'Não encontramos a assinatura. Ela pode levar alguns instantes para ser processada.',
    verifySubscriptionError: 'Erro ao verificar a assinatura: {message}',
    verifyPaymentError: 'Erro ao verificar o pagamento: {message}',
    unlimited: 'Ilimitadas',
    processingTitle: 'Processando sua assinatura',
    processingBody: 'Aguarde enquanto confirmamos seu pagamento...',
    verificationTitle: 'Verificação da assinatura',
    verificationError: 'Erro na verificação',
    backToPricing: 'Voltar aos preços',
    trialStarted: 'Seu teste grátis começou!',
    welcome: 'Boas-vindas ao {plan}',
    trialAccessTitle: '7 dias de acesso completo',
    trialAccessBefore: 'Você tem acesso completo a todos os recursos do {plan} até',
    trialAccessAfter: '.',
    trialNoCharge: 'Você não será cobrado até o fim do teste. Cancele quando quiser antes disso e não paga nada.',
    includedTitle: 'O que o seu teste inclui:',
    processingHours: '{hours} horas de processamento de vídeo por mês',
    clippingOne: 'Cortes com IA de vídeos longos ({n} busca nova)',
    clippingMany: 'Cortes com IA de vídeos longos ({n} buscas novas)',
    captioning: 'Legendas automáticas',
    reframing: 'Reenquadramento de vídeos para 9:16, 1:1, 4:5 ou 16:9',
    editorRenders: 'Exportação de projetos do editor',
    aiVideos: '{n} vídeos do Agente de IA por mês',
    imageRegenerations: '{n} novas gerações de imagem por projeto',
    imageEdits: '{n} edições de imagem por projeto',
    animations: '{n} animações de imagem em vídeo por projeto',
    voiceRegenerations: '{n} novas gerações de voz por projeto',
    noWatermark: 'Sem marca d’água nos vídeos',
    editorAccess: 'Acesso ao editor de vídeo',
    support: 'Suporte prioritário por e-mail',
    firstProject: 'Crie seu primeiro projeto',
    viewAccount: 'Ver minha conta',
    activated: 'Assinatura ativada!',
    startCreating: 'Começar a criar',
    cancelSeoTitle: "Pagamento não concluído",
    cancelSeoDescription: "Você saiu do pagamento antes de pagar. Nenhuma cobrança foi feita. Volte aos preços para ver nossos planos.",
    cancelTitle: "Pagamento não concluído",
    cancelAlertTitle: "Nenhuma cobrança foi feita",
    cancelBody: "Você saiu do pagamento antes de pagar. Nenhuma cobrança foi feita.",
    returnToPricing: 'Voltar aos preços',
    goToAccount: 'Ir para minha conta',
    backToMyVideo: "Voltar ao meu vídeo",
  },
  projectTimeline: {
    unknown: 'Desconhecido',
    recent: 'Criado agora há pouco',
    aspectRatio: 'Formato: {value}',
    padding: 'Preenchimento: {value}',
    complete: '{n}% pronto',
  },
  projectPage: {
    captionsSeoTitle: '{title} - Projeto de legendas',
    captionsSeoFallback: 'Detalhes do projeto de legendas',
    captionsSeoDescription: 'Veja e edite as legendas do seu vídeo. Personalize o estilo, baixe o vídeo legendado e gerencie seu projeto de transcrição.',
    seoTitle: '{title} - Detalhes do projeto',
    reframeSeoFallback: 'Detalhes do projeto de reenquadramento',
    seoFallback: 'Detalhes do projeto',
    reframeSeoDescription: 'Veja e baixe seu vídeo reenquadrado. Acompanhe a mudança de formato e gerencie seu projeto de reenquadramento.',
    clippingSeoDescription: 'Veja e gerencie seu projeto de cortes com IA. Acompanhe o progresso, veja os momentos virais encontrados e baixe seus vídeos curtos.',
    reprompt: 'Buscar de novo',
    premium: 'Premium',
    promptFoundNothing: 'O pedido {n} (“{prompt}”) não encontrou clipes. Tente de novo com outra instrução.',
    repromptTab: 'Busca #{n}',
    repromptProcessing: 'Processando a nova busca...',
    customPrompt: 'Instrução personalizada:',
    repromptFailed: 'A nova busca falhou',
    repromptFailedBody: 'Infelizmente a nova busca falhou. Você pode tentar de novo com outra instrução.',
  },
  newProject: {
    unreadableLink: 'Não conseguimos ler este link. Confira se o vídeo é público, ou tente um link do YouTube, Twitch, Kick, Drive ou X.',
    channelLink: "Esse é o link de um canal ou playlist. Cole o link de um vídeo dele.",
    noLinkInText: "Esse texto não tem um link de vídeo. Cole o link de um vídeo.",
    twitchNotLive: "Esse canal da Twitch não está ao vivo agora. Cole o link de uma transmissão passada (um VOD).",
    videoUnavailable: "Este vídeo é privado, foi apagado ou está bloqueado em alguns países. Tente outro link ou envie o arquivo.",
    noSourceYet: 'Adicione um vídeo (link ou arquivo) e aguarde os dados carregarem.',
    noDuration: 'Não conseguimos saber a duração do vídeo. Tente outro vídeo.',
    reframeTooLong: 'O reenquadramento processa até 30 minutos por vez. Escolha uma parte de 30 minutos ou menos.',
    partTooShort: 'Os cortes com IA precisam de pelo menos 5 minutos para encontrar clipes. Escolha uma parte mais longa.',
    videoTooShort: 'Seu vídeo tem menos de 5 minutos. Escolha um vídeo mais longo para gerar clipes.',
    noFile: 'Erro interno: um arquivo foi escolhido, mas não há nenhum.',
    uploadInProgress: 'Aguarde o envio do arquivo terminar.',
    uploadFirst: 'Envie o arquivo escolhido antes de criar o projeto.',
    notAVideo: 'Tipo de arquivo inválido. Escolha um arquivo de vídeo.',
    invalidUrl: 'Digite um link de vídeo válido.',
    infoNotReady: 'Os dados do vídeo ainda não chegaram. Aguarde um instante ou confira o link.',
    noSource: 'Adicione um vídeo.',
    metadataFailed: 'Não conseguimos ler os dados do arquivo escolhido. Tente outro arquivo.',
    selectFileFirst: 'Escolha um arquivo primeiro.',
    uploadFailed: 'O envio do arquivo falhou. Tente de novo.',
    uploaded: 'Arquivo enviado',
    reframeDemoTop: 'A IA mantém o assunto no quadro, plano a plano.',
    reframeDemoBottom: 'Vertical, quadrado ou horizontal. Sem tarjas pretas.',
  },
  remixStickers: {
    change: 'Trocar figurinha ({label})',
    remove: 'Remover figurinha ({label})',
  },
  notFoundPage: {
    title: 'Página não encontrada',
    text: 'Esta página não existe ou mudou de lugar. É para cá que a maioria vai:',
    home: 'Início',
    aiAgent: 'Crie um vídeo a partir de uma ideia',
    tools: 'Verificador de monetização do YouTube grátis',
    pricing: 'Preços',
  },
  affiliates: {
    page: {
      seoTitle: 'Programa de afiliados: 30% de cada pagamento',
      seoDescription: 'Ganhe 30% de cada pagamento dos criadores que você trouxer ao Clip-Short, enquanto continuarem assinantes. Pago todo mês por PayPal, Wise ou Vodafone Cash.',
      badge: 'Programa de afiliados',
      title: 'Ganhe 30% de cada pagamento, enquanto eles continuarem',
      subtitle: 'Compartilhe o Clip-Short com os criadores que seguem você. Quando alguém se cadastra pelo seu link e assina, você recebe 30% de tudo o que essa pessoa paga, todo mês que ela continuar pagando.',
      join: 'Quero ser afiliado',
      facts: {
        rate: '30% de cada pagamento',
        link: 'Link válido por 60 dias',
        payout: 'Pagamento mensal',
      },
      stepsTitle: 'Como funciona',
      steps: {
        link: { title: 'Pegue o seu link', text: 'Entre pela sua conta em um minuto. O seu link leva o seu próprio código, por exemplo clip-short.com/?via=seunome.' },
        share: { title: 'Compartilhe', text: 'Coloque na descrição dos seus vídeos, na bio, nos seus posts ou no seu grupo. Quem abrir e se cadastrar nos 60 dias seguintes conta como seu.' },
        paid: { title: 'Receba todo mês', text: 'Você ganha 30% de cada pagamento que eles fizerem. Quando o seu saldo confirmado passa de US$20, enviamos por PayPal, Wise ou Vodafone Cash.' },
      },
      termsTitle: 'As condições, sem letra miúda',
      terms: [
        '30% de cada pagamento que um cliente trazido por você fizer, depois de qualquer desconto, enquanto ele continuar assinante.',
        'O seu link vale por 60 dias a partir da primeira visita. Se a pessoa chegou antes pelo link de outro afiliado, vale o primeiro link.',
        'Uma comissão é confirmada 30 dias depois do pagamento, quando ele não pode mais ser reembolsado. Um pagamento reembolsado não gera nada.',
        'Pagamos as comissões confirmadas uma vez por mês, por PayPal, Wise ou Vodafone Cash, quando somam US$20. O que faltar passa para o mês seguinte.',
        'Só contam contas novas: quem já tinha conta ou já pagava não é indicação, e ninguém pode indicar a si mesmo.',
      ],
      rulesTitle: 'Não é permitido',
      rules: [
        'Anúncios pagos com o nosso nome: não dê lances em “Clip-Short” nem nas suas variações no Google, no YouTube ou em qualquer outra plataforma de anúncios.',
        'Spam: nada de mensagens, e-mails ou comentários não solicitados, nem postar o seu link onde ele não é bem-vindo.',
        'Promessas que não fazemos: nada de avaliações falsas, descontos inventados ou afirmações sobre o Clip-Short que não sejam verdade.',
      ],
      rulesNote: 'Se um afiliado quebrar essas regras, pausamos o link dele e ele deixa de gerar comissões.',
      faqTitle: 'Perguntas',
      faq: {
        who: { q: 'Quem pode participar?', a: 'Qualquer pessoa com uma conta no Clip-Short. Você não precisa ser cliente pagante e não existe um mínimo de seguidores.' },
        track: { q: 'Como vocês sabem que alguém veio por mim?', a: 'O seu link leva o seu código. O navegador da pessoa guarda esse código por 60 dias, e ele é ligado a ela quando cria a conta. No seu painel você vê as visitas, os cadastros e cada comissão.' },
        when: { q: 'Quando eu recebo?', a: 'Cada comissão é confirmada 30 dias depois do pagamento. Uma vez por mês enviamos tudo o que foi confirmado, desde que some pelo menos US$20.' },
        how: { q: 'Como o dinheiro é enviado?', a: 'Por PayPal, Wise ou Vodafone Cash, para a conta que você informar. Você pode mudar quando quiser no seu painel.' },
        refund: { q: 'E se um cliente pedir reembolso?', a: 'Um pagamento reembolsado não gera comissão. Por isso as comissões só são confirmadas depois de 30 dias.' },
        life: { q: 'É mesmo enquanto eles continuarem?', a: 'Sim. Cada renovação mensal ou anual de um cliente que você trouxe rende 30% de novo, enquanto ele continuar pagando e o programa existir.' },
      },
      ctaTitle: 'Pronto para compartilhar o Clip-Short?',
      ctaText: 'Pegar o seu link leva um minuto.',
    },
    dashboard: {
      nav: 'Afiliados',
      heading: 'Programa de afiliados',
      intro: 'Ganhe 30% de cada pagamento das pessoas que você trouxer, enquanto continuarem assinantes.',
      readTerms: 'Ler as condições',
      joinTitle: 'Para onde enviamos o seu dinheiro?',
      method: 'Forma de pagamento',
      methods: {
        paypal: 'PayPal',
        wise: 'Wise',
        vodafone_cash: 'Vodafone Cash',
        other: 'Outra',
      },
      details: {
        paypal: 'Seu e-mail do PayPal',
        wise: 'Seu e-mail da Wise',
        vodafone_cash: 'Seu número do Vodafone Cash',
        other: 'Como devemos pagar você?',
      },
      placeholders: {
        paypal: 'voce@email.com',
        wise: 'voce@email.com',
        vodafone_cash: '010 1234 5678',
        other: 'A conta e o que precisarmos para enviar',
      },
      agree: 'Ao entrar você aceita as condições do programa: nada de anúncios pagos com o nosso nome e nada de spam.',
      join: 'Pegar meu link',
      joining: 'Entrando…',
      errors: {
        invalid_payout_details: 'Isso não parece certo para esta forma de pagamento. Confira e tente de novo.',
        invalid_payout_method: 'Escolha como quer receber.',
        generic: 'Algo deu errado. Tente de novo.',
      },
      loadError: 'Não conseguimos carregar sua conta de afiliado.',
      tryAgain: 'Tentar de novo',
      yourLink: 'Seu link',
      linkHint: 'Também funciona se você adicionar ?via={code} a qualquer página do clip-short.com.',
      copy: 'Copiar',
      copied: 'Copiado',
      clicks: 'Visitas',
      signups: 'Cadastros',
      customers: 'Clientes pagantes',
      pending: 'Pendente',
      pendingHint: 'Confirmado 30 dias depois de cada pagamento',
      approved: 'Confirmado',
      approvedHint: 'Pago todo mês a partir de US$20',
      paid: 'Pago a você',
      noMoney: 'Nada ainda. Uma comissão aparece aqui assim que um cliente trazido por você paga.',
      recentTitle: 'Comissões',
      columns: {
        date: 'Pagamento',
        amount: 'Pagou',
        commission: 'Você ganha',
        status: 'Situação',
      },
      statuses: {
        pending: 'Pendente até {date}',
        approved: 'Confirmada',
        paid: 'Paga',
        void: 'Reembolsada',
      },
      payoutTitle: 'Dados de pagamento',
      change: 'Alterar',
      save: 'Salvar',
      saving: 'Salvando…',
      cancel: 'Cancelar',
      paused: 'Seu link está pausado: não traz clientes novos nem gera comissões novas. Fale com a gente se achar que é um engano.',
    },
  },
  renderStage: {
    preparing: 'Preparando seu vídeo…',
    scene: 'Preparando a cena {n} de {total}…',
    clip: 'Preparando o clipe {n} de {total}…',
    frames: 'Criando seu vídeo · {percent}%',
    finishing: 'Dando os últimos retoques…',
    saving: 'Salvando seu vídeo · {percent}%',
    done: 'Pronto',
  },
};
